import { interpolateData } from 'features/generalQuestionnaire/functions';
import { TFunction } from 'shared/i18n';
import { sharedConfig } from 'syncedData/sharedConfig';

const constants = {};

export default (tFunction: TFunction, interpolationData = {}) => {
  const t = (key: string, defaultValue: string, interpolateOnly = false) => {
    if (interpolateOnly) {
      return interpolateData(defaultValue, interpolationData);
    }

    return tFunction(key, {
      defaultValue,
      constants: { ...sharedConfig, ...constants },
      variant: { id: 9, slug: 'aok', name: 'AOK', value: 'aok' },
      ...interpolationData,
    });
  };

  return {
    createdAt: '2024-12-05T12:46:31.978Z',
    updatedAt: '2025-06-25T15:18:04.053Z',
    publishedAt: '2024-12-30T14:34:45.943Z',
    meta: {
      id: 4,
      name: 'public-health-de',
      slug: 'public-health-aok',
      published: true,
      regions: ['de'],
      type: 'singleRegion',
      isDependent: false,
      translationKey: 'publicHealthDe',
      questionList: [
        {
          id: 447,
          name: 'variant',
        },
        {
          id: 898,
          name: 'loading',
        },
        {
          id: 67,
          name: 'intro',
        },
        {
          id: 864,
          name: 'introTk',
        },
        {
          id: 863,
          name: 'introBkkfirmus',
        },
        {
          id: 68,
          name: 'email',
        },
        {
          id: 422,
          name: 'hasPublicHealth',
        },
        {
          id: 423,
          name: 'hasPublicHealthInActive',
        },
        {
          id: 421,
          name: 'hasPublicHealthInPendingBlocker',
        },
        {
          id: 424,
          name: 'hasPublicHealthInActiveBlocker',
        },
        {
          id: 69,
          name: 'name',
        },
        {
          id: 319,
          name: 'lastNameAtBirth',
        },
        {
          id: 70,
          name: 'dateOfBirth',
        },
        {
          id: 71,
          name: 'gender',
        },
        {
          id: 72,
          name: 'hasAddressInGermany',
        },
        {
          id: 73,
          name: 'address',
        },
        {
          id: 448,
          name: 'addressVar',
        },
        {
          id: 74,
          name: 'occupation',
        },
        {
          id: 75,
          name: 'otherSituation',
        },
        {
          id: 152,
          name: 'otherSituationDescription',
        },
        {
          id: 76,
          name: 'annualIncome',
        },
        {
          id: 78,
          name: 'jobStartDate',
        },
        {
          id: 80,
          name: 'firstTimeEmployedInGermany',
        },
        {
          id: 77,
          name: 'coverageStartDate',
        },
        {
          id: 136,
          name: 'universityInGermany',
        },
        {
          id: 137,
          name: 'universityInGermanyBlocker',
        },
        {
          id: 139,
          name: 'university',
        },
        {
          id: 338,
          name: 'universityNotListedBlocker',
        },
        {
          id: 147,
          name: 'universityName',
        },
        {
          id: 146,
          name: 'universityAddress',
        },
        {
          id: 148,
          name: 'worksMoreThanTwentyHours',
        },
        {
          id: 149,
          name: 'worksMoreThanTwentyHoursBlocker',
        },
        {
          id: 150,
          name: 'universityStartDate',
        },
        {
          id: 140,
          name: 'familyReunionVisaBlocker',
        },
        {
          id: 144,
          name: 'phdDoctorateBlocker',
        },
        {
          id: 151,
          name: 'internBlocker',
        },
        {
          id: 154,
          name: 'hasGermanPublicHealthInsurance',
        },
        {
          id: 81,
          name: 'hasPublicHealthInsurance',
        },
        {
          id: 82,
          name: 'previousCountryOfInsurance',
        },
        {
          id: 158,
          name: 'hadOneDayPublicHealthInsurance',
        },
        {
          id: 161,
          name: 'pastFiveYearsInGermany',
        },
        {
          id: 288,
          name: 'insuranceTwelveMonths',
        },
        {
          id: 287,
          name: 'insuranceTwentyFourMonths',
        },
        {
          id: 164,
          name: 'studentHasPublicHealthInsurance',
        },
        {
          id: 153,
          name: 'studentAboveAgeBlocker',
        },
        {
          id: 165,
          name: 'studentPreviousCountryOfInsurance',
        },
        {
          id: 172,
          name: 'ehicCard',
        },
        {
          id: 277,
          name: 'weCanHelpStudentBlocker',
        },
        {
          id: 270,
          name: 'expatOrPrivateHealthInsurance',
        },
        {
          id: 278,
          name: 'studentOnExpatOrPrivateBlocker',
        },
        {
          id: 281,
          name: 'currentlyOnPrivate',
        },
        {
          id: 283,
          name: 'lastInsuranceInGermany',
        },
        {
          id: 284,
          name: 'employmentWithinTwoMonthsOfArrival',
        },
        {
          id: 285,
          name: 'inEligibleTwoMonthsAfterArrivalBlocker',
        },
        {
          id: 155,
          name: 'previousInsurer',
        },
        {
          id: 286,
          name: 'lastProviderInGermany',
        },
        {
          id: 156,
          name: 'unlistedPreviousInsurer',
        },
        {
          id: 163,
          name: 'ineligibleOverPrivateThreshold',
        },
        {
          id: 162,
          name: 'ineligibleUnderPrivateThreshold',
        },
        {
          id: 160,
          name: 'ineligibleExpatHealth',
        },
        {
          id: 159,
          name: 'ineligibleLearnOptions',
        },
        {
          id: 282,
          name: 'ineligiblePrivateBlocker',
        },
        {
          id: 293,
          name: 'insuranceHistoryProcessing',
        },
        {
          id: 316,
          name: 'miniJobInsuredEuBlocker',
        },
        {
          id: 331,
          name: 'switchEmployedProvidersBlocker',
        },
        {
          id: 332,
          name: 'switchProvidersBlocker',
        },
        {
          id: 313,
          name: 'employerHasAlreadySignedUpBlocker',
        },
        {
          id: 896,
          name: 'switchingFromPrivate',
        },
        {
          id: 897,
          name: 'dateFallingBelowThreshold',
        },
        {
          id: 314,
          name: 'employerName',
        },
        {
          id: 317,
          name: 'jobTitle',
        },
        {
          id: 318,
          name: 'companyAddress',
        },
        {
          id: 325,
          name: 'hasTaxNumber',
        },
        {
          id: 327,
          name: 'monthlyIncomeForNextYear',
        },
        {
          id: 326,
          name: 'agenturFurArbeitBenefits',
        },
        {
          id: 328,
          name: 'hasOtherIncome',
        },
        {
          id: 330,
          name: 'otherIncome',
        },
        {
          id: 329,
          name: 'otherIncomeMonthlyRevenue',
        },
        {
          id: 320,
          name: 'placeOfBirthCity',
        },
        {
          id: 157,
          name: 'placeOfBirthCountry',
        },
        {
          id: 289,
          name: 'nationality',
        },
        {
          id: 290,
          name: 'receivesPension',
        },
        {
          id: 291,
          name: 'hasDependentsToCover',
        },
        {
          id: 292,
          name: 'hasChildren',
        },
        {
          id: 901,
          name: 'addons',
        },
        {
          id: 336,
          name: 'signature',
        },
        {
          id: 450,
          name: 'signatureBarmer',
        },
        {
          id: 324,
          name: 'review',
        },
        {
          id: 337,
          name: 'success',
        },
        {
          id: 900,
          name: 'successTk',
        },
        {
          id: 899,
          name: 'successBkkfirmus',
        },
      ],
      vertical: {
        data: {
          id: 3,
          attributes: {
            name: 'public-health-de',
            colorCode: '#FFF7EC',
            createdAt: '2024-12-05T12:52:44.370Z',
            updatedAt: '2025-06-09T13:34:25.271Z',
            publishedAt: '2024-12-30T14:15:15.940Z',
            insuranceType: 'PUBLIC_HEALTH',
            image: {
              data: {
                id: 2486,
                attributes: {
                  name: 'public 456x456.png',
                  alternativeText: 'Pill on orange background',
                  caption: null,
                  width: 456,
                  height: 456,
                  formats: {
                    thumbnail: {
                      ext: '.png',
                      url: 'https://cms.cdn.feather-insurance.com/thumbnail_public_456x456_33a7ba824f/thumbnail_public_456x456_33a7ba824f.png',
                      hash: 'thumbnail_public_456x456_33a7ba824f',
                      mime: 'image/png',
                      name: 'thumbnail_public 456x456.png',
                      path: null,
                      size: 24.98,
                      width: 156,
                      height: 156,
                      sizeInBytes: 24978,
                    },
                  },
                  hash: 'public_456x456_33a7ba824f',
                  ext: '.png',
                  mime: 'image/png',
                  size: 132.5,
                  url: 'https://cms.cdn.feather-insurance.com/public_456x456_33a7ba824f/public_456x456_33a7ba824f.png',
                  previewUrl: null,
                  provider:
                    '@strapi-community/strapi-provider-upload-google-cloud-storage',
                  provider_metadata: null,
                  createdAt: '2025-04-22T11:57:28.557Z',
                  updatedAt: '2025-04-22T11:57:28.557Z',
                },
              },
            },
          },
        },
      },
      constants: {},
      variants: [
        {
          id: 1,
          slug: 'tk',
          name: 'TK',
          value: 'tk',
        },
        {
          id: 2,
          slug: 'barmer',
          name: 'BARMER',
          value: 'barmer',
        },
        {
          id: 3,
          slug: 'dak',
          name: 'DAK',
          value: 'dak',
        },
        {
          id: 4,
          slug: 'bkk-firmus',
          name: 'BKK firmus',
          value: 'bkk_firmus',
        },
        {
          id: 9,
          slug: 'aok',
          name: 'AOK',
          value: 'aok',
        },
      ],
      hiddenFields: {},
      insuranceType: 'PUBLIC_HEALTH',
      prefilledAnswers: {
        variant: 'aok',
        variantData: {
          id: 9,
          slug: 'aok',
          name: 'AOK',
          value: 'aok',
        },
      },
    },
    questions: [
      {
        id: 'loading',
        __component: 'questionnaire.processing',
        required: true,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 20,
          description: null,
          timeoutTime: 1500,
          textList: [
            t(
              'questionnaire.publicHealthDe.signup.loading.props.textList.0',
              'Loading sign up'
            ),
          ],
        },
        type: 'PROCESSING',
      },
      {
        id: 'intro',
        __component: 'questionnaire.intro',
        required: false,
        groupId: 'intro',
        screen: {
          id: 95,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.intro.intro.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 7,
          title: t(
            'questionnaire.publicHealthDe.intro.intro.props.title',
            "Let's get you insured!"
          ),
          subTitle: null,
          hideIcon: false,
          infoCardsDisplay: 'horizontal',
          infoCards: [
            {
              id: 5,
              title: t(
                'questionnaire.publicHealthDe.intro.intro.option.0.title',
                'Application'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.intro.intro.option.0.description',
                'Apply for your new public health insurance with {{answers.variantData.name}}.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_1_and_Application_105c562672/Icon_with_1_and_Application_105c562672.png',
            },
            {
              id: 6,
              title: t(
                'questionnaire.publicHealthDe.intro.intro.option.1.title',
                'Confirmation of coverage'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.intro.intro.option.1.description',
                'You will get notified by email within 2 weeks.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_2_and_Shield_977b6e49db/Icon_with_2_and_Shield_977b6e49db.png',
            },
            {
              id: 7,
              title: t(
                'questionnaire.publicHealthDe.intro.intro.option.2.title',
                'Upload photo'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.intro.intro.option.2.description',
                'Done digitally in your account.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_3_and_photo_a26761b53d/Icon_with_3_and_photo_a26761b53d.png',
            },
            {
              id: 8,
              title: t(
                'questionnaire.publicHealthDe.intro.intro.option.3.title',
                'Receive health card'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.intro.intro.option.3.description',
                'By mail, a few weeks after photo upload or when insurance starts.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_4_and_card_7d97901e75/Icon_with_4_and_card_7d97901e75.png',
            },
          ],
        },
        type: 'INTRO',
      },
      {
        id: 'introTk',
        __component: 'questionnaire.intro',
        required: false,
        groupId: 'signup',
        screen: {
          id: 713,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.introTk.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 53,
          title: t(
            'questionnaire.publicHealthDe.signup.introTk.props.title',
            "Let's get you insured!"
          ),
          subTitle: null,
          hideIcon: false,
          infoCardsDisplay: 'horizontal',
          infoCards: [
            {
              id: 33,
              title: t(
                'questionnaire.publicHealthDe.signup.introTk.option.0.title',
                'Application'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.signup.introTk.option.0.description',
                'Apply for your new public health insurance with {{answers.variantData.name}}.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_1_and_Application_105c562672/Icon_with_1_and_Application_105c562672.png',
            },
            {
              id: 35,
              title: t(
                'questionnaire.publicHealthDe.signup.introTk.option.1.title',
                'Confirmation of coverage'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.signup.introTk.option.1.description',
                'You will get notified by email within 2 weeks.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_2_and_Shield_977b6e49db/Icon_with_2_and_Shield_977b6e49db.png',
            },
            {
              id: 36,
              title: t(
                'questionnaire.publicHealthDe.signup.introTk.option.2.title',
                'Submit your photo'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.signup.introTk.option.2.description',
                'TK will send you a letter with the instructions'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_3_and_photo_a26761b53d/Icon_with_3_and_photo_a26761b53d.png',
            },
            {
              id: 37,
              title: t(
                'questionnaire.publicHealthDe.signup.introTk.option.3.title',
                'Receive health card'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.signup.introTk.option.3.description',
                'By mail, a few weeks after photo upload or when insurance starts.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_4_and_card_7d97901e75/Icon_with_4_and_card_7d97901e75.png',
            },
          ],
        },
        type: 'INTRO',
      },
      {
        id: 'introBkkfirmus',
        __component: 'questionnaire.intro',
        required: false,
        groupId: 'signup',
        screen: {
          id: 714,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.introBkkfirmus.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 52,
          title: t(
            'questionnaire.publicHealthDe.signup.introBkkfirmus.props.title',
            "Let's get you insured!"
          ),
          subTitle: null,
          hideIcon: false,
          infoCardsDisplay: 'horizontal',
          infoCards: [
            {
              id: 34,
              title: t(
                'questionnaire.publicHealthDe.signup.introBkkfirmus.option.0.title',
                'Application'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.signup.introBkkfirmus.option.0.description',
                'Apply for your new public health insurance with {{answers.variantData.name}}.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_1_and_Application_105c562672/Icon_with_1_and_Application_105c562672.png',
            },
            {
              id: 38,
              title: t(
                'questionnaire.publicHealthDe.signup.introBkkfirmus.option.1.title',
                'Confirmation of coverage'
              ),
              iconPosition: 'top',
              description: t(
                'questionnaire.publicHealthDe.signup.introBkkfirmus.option.1.description',
                'You will usually get notified by postal mail within 2 weeks.'
              ),
              iconSize: 'large',
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_2_and_Shield_977b6e49db/Icon_with_2_and_Shield_977b6e49db.png',
            },
          ],
        },
        type: 'INTRO',
      },
      {
        id: 'email',
        __component: 'questionnaire.email-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 53,
          value: 'Personal',
        },
        screen: {
          id: 96,
          question: t(
            'questionnaire.publicHealthDe.signup.email.screen.question',
            'What’s your email address?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.email.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Standalone',
        },
        type: 'EMAIL',
        props: {},
      },
      {
        id: 'hasPublicHealth',
        __component: 'questionnaire.has_policy-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 301,
          value: 'Personal',
        },
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 1,
          insuranceType: 'PUBLIC_HEALTH',
        },
        type: 'HAS_POLICY',
      },
      {
        id: 'hasPublicHealthInActive',
        __component: 'questionnaire.radio-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 302,
          value: 'Personal',
        },
        screen: {
          id: 368,
          question: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInActive.screen.question',
            'We found another policy in your account'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInActive.screen.description',
            'Let’s make sure we’re sending you the right way.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInActive.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 42,
          mapValue: {
            CHANGE_PROVIDERS: t(
              'questionnaire.publicHealthDe.signup.hasPublicHealthInActive.option.changeProvidersOption',
              'I want to change providers'
            ),
            POLICY_NOT_ACTIVE: t(
              'questionnaire.publicHealthDe.signup.hasPublicHealthInActive.option.policyNotActiveOption',
              'My policy isn’t active anymore'
            ),
            ADJUST_POLICY: t(
              'questionnaire.publicHealthDe.signup.hasPublicHealthInActive.option.adjustPolicyOption',
              'I want to adjust my policy'
            ),
          },
        },
        type: 'RADIO',
      },
      {
        id: 'hasPublicHealthInPendingBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 64,
          title: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInPendingBlocker.props.title',
            'You already submitted an application'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInPendingBlocker.props.description',
            'Applications are usually processed by the provider within 1 week. If you need to modify your application or get a status update, please reach out to us.\n\nNote that applying with multiple providers at the same time can lead to duplicate payments and delays in processing. If your previous application was canceled, you can continue below.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 81,
              caption: t(
                'questionnaire.publicHealthDe.signup.hasPublicHealthInPendingBlocker.option.0.caption',
                'Contact us'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 79,
              caption: t(
                'questionnaire.publicHealthDe.signup.hasPublicHealthInPendingBlocker.option.1.caption',
                'Continue'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'submit',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'hasPublicHealthInActiveBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 63,
          title: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInActiveBlocker.props.title',
            'Reach out to us'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInActiveBlocker.props.description',
            'You can contact us if you’d like to make changes to your public health policy or application and we’ll help you through the process.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 80,
              caption: t(
                'questionnaire.publicHealthDe.signup.hasPublicHealthInActiveBlocker.option.0.caption',
                'Contact us'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'name',
        __component: 'questionnaire.name-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 55,
          value: 'Personal',
        },
        screen: {
          id: 98,
          question: t(
            'questionnaire.publicHealthDe.signup.name.screen.question',
            "What's your full legal name?"
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.name.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'NAME',
        props: {},
      },
      {
        id: 'lastNameAtBirth',
        __component: 'questionnaire.input-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 241,
          value: 'Personal',
        },
        screen: {
          id: 293,
          question: t(
            'questionnaire.publicHealthDe.signup.lastNameAtBirth.screen.question',
            'What was your last name at birth?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.lastNameAtBirth.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 28,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.lastNameAtBirth.props.placeholder',
            'Last name at birth'
          ),
          label: null,
          maxLength: null,
          minLength: null,
        },
        type: 'INPUT',
      },
      {
        id: 'dateOfBirth',
        __component: 'questionnaire.date-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 54,
          value: 'Personal',
        },
        screen: {
          id: 97,
          question: t(
            'questionnaire.publicHealthDe.signup.dateOfBirth.screen.question',
            "What's your date of birth?"
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.dateOfBirth.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 10,
          yearRange: {
            id: 11,
            min: {
              id: 21,
              op: 'subtract',
              value: 100,
              type: 'years',
            },
            max: {
              id: 22,
              op: 'add',
              value: 0,
              type: 'years',
            },
          },
        },
        validations: [
          {
            id: 9,
            op: 'DateIsInPast',
            msg: {
              id: 9,
              type: 'Error',
              value: t(
                'questionnaire.publicHealthDe.signup.dateOfBirth.validations.0.msg.value',
                'Please select a date that is in the past.'
              ),
            },
            variable: null,
          },
        ],
        type: 'DATE',
      },
      {
        id: 'gender',
        __component: 'questionnaire.radio-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 57,
          value: 'Personal',
        },
        screen: {
          id: 100,
          question: t(
            'questionnaire.publicHealthDe.signup.gender.screen.question',
            "What's your gender?"
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.gender.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 19,
          mapValue: {
            FEMALE: t(
              'questionnaire.publicHealthDe.signup.gender.option.femaleOption',
              'Female'
            ),
            MALE: t(
              'questionnaire.publicHealthDe.signup.gender.option.maleOption',
              'Male'
            ),
            OTHER: t(
              'questionnaire.publicHealthDe.signup.gender.option.otherOption',
              'Gender nonconforming'
            ),
          },
        },
        type: 'RADIO',
      },
      {
        id: 'hasAddressInGermany',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 58,
          value: 'Personal',
        },
        screen: {
          id: 101,
          question: t(
            'questionnaire.publicHealthDe.signup.hasAddressInGermany.screen.question',
            'Do you have a German address?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasAddressInGermany.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'address',
        __component: 'questionnaire.address-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 59,
          value: 'Personal',
        },
        screen: {
          id: 102,
          question: t(
            'questionnaire.publicHealthDe.signup.address.screen.question',
            'What’s your address in Germany?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.address.screen.description',
            'You’ll get your health card by mail 2-3 weeks after your coverage is confirmed and you uploaded your photo. Make sure to fill the C/O field if your name is not on the front door and mailbox.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.address.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: {
            id: 7,
            title: t(
              'questionnaire.publicHealthDe.signup.address.screen.skipDetails.title',
              'Skip'
            ),
            path: null,
            skipQuestion: {
              value: null,
            },
          },
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 3,
          countryCode: t(
            'questionnaire.publicHealthDe.signup.address.props.countryCode',
            'de'
          ),
          dynamicCountryCode: null,
        },
        type: 'ADDRESS',
      },
      {
        id: 'addressVar',
        __component: 'questionnaire.address-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 311,
          value: 'Personal',
        },
        screen: {
          id: 377,
          question: t(
            'questionnaire.publicHealthDe.signup.addressVar.screen.question',
            'What’s your address in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.addressVar.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 25,
          countryCode: t(
            'questionnaire.publicHealthDe.signup.addressVar.props.countryCode',
            'de'
          ),
          dynamicCountryCode: null,
        },
        type: 'ADDRESS',
      },
      {
        id: 'occupation',
        __component: 'questionnaire.radio-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 60,
          value: 'Personal',
        },
        screen: {
          id: 103,
          question: t(
            'questionnaire.publicHealthDe.signup.occupation.screen.question',
            'What’s your main occupation in Germany?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.occupation.screen.description',
            'This can be your upcoming occupation, e.g. if you have a job lined up.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.occupation.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 20,
          mapValue: {
            UNIVERSITY_STUDENT: t(
              'questionnaire.publicHealthDe.signup.occupation.option.universityStudentOption',
              'University student'
            ),
            EMPLOYED: t(
              'questionnaire.publicHealthDe.signup.occupation.option.employedOption',
              'Employed'
            ),
            JOB_OFFER: t(
              'questionnaire.publicHealthDe.signup.occupation.option.jobOfferOption',
              'I have a job offer'
            ),
            SELF_EMPLOYED: t(
              'questionnaire.publicHealthDe.signup.occupation.option.selfEmployedOption',
              'Self-employed'
            ),
            OTHER: t(
              'questionnaire.publicHealthDe.signup.occupation.option.otherOption',
              'Other'
            ),
          },
        },
        type: 'RADIO',
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.radio-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 61,
          value: 'Personal',
        },
        screen: {
          id: 104,
          question: t(
            'questionnaire.publicHealthDe.signup.otherSituation.screen.question',
            "What's your situation?"
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.otherSituation.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 21,
          mapValue: {
            RETIRED: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.retiredOption',
              'Retired'
            ),
            LANGUAGE_SCHOOL: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.languageSchoolOption',
              'Language school'
            ),
            JOB_HUNTING: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.jobHuntingOption',
              'Searching for a job'
            ),
            FAMILY_REUNION: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.familyReunionOption',
              'Family reunion visa'
            ),
            APPRENTICE: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.apprenticeOption',
              'Apprentice (Azubi)'
            ),
            FSJ: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.fsjOption',
              'Freiwilliges Soziales Jahr (voluntary year)'
            ),
            PHD: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.phdOption',
              'PhD / Doctorate'
            ),
            INTERN: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.internOption',
              'Intern'
            ),
            OTHER: t(
              'questionnaire.publicHealthDe.signup.otherSituation.option.otherOption',
              'Other'
            ),
          },
        },
        type: 'RADIO',
      },
      {
        id: 'otherSituationDescription',
        __component: 'questionnaire.text-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 323,
          value: 'Personal',
        },
        screen: {
          id: 390,
          question: t(
            'questionnaire.publicHealthDe.signup.otherSituationDescription.screen.question',
            'Describe your situation in detail'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.otherSituationDescription.screen.description',
            'Let us know about your occupation, date of arrival in Germany, if you have a residence permit (if yes, for how long), as well as any other relevant details. This will help us determine your eligibility.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.otherSituationDescription.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 4,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.otherSituationDescription.props.placeholder',
            'e.g. civil servant, National D Visa, living in Germany since 2022, no health insurance currently'
          ),
          maxLength: null,
        },
        type: 'TEXT',
      },
      {
        id: 'annualIncome',
        __component: 'questionnaire.currency-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 62,
          value: 'Personal',
        },
        screen: {
          id: 105,
          question: t(
            'questionnaire.publicHealthDe.signup.annualIncome.screen.question',
            'What’s your yearly employment income before taxes?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.annualIncome.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 1,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.annualIncome.props.placeholder',
            'Yearly income in Euros'
          ),
        },
        type: 'CURRENCY',
      },
      {
        id: 'jobStartDate',
        __component: 'questionnaire.date-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 65,
          value: 'Personal',
        },
        screen: {
          id: 109,
          question: t(
            'questionnaire.publicHealthDe.signup.jobStartDate.screen.question',
            "What's the start date of your employment contract?"
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.jobStartDate.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 20,
          yearRange: {
            id: 21,
            min: {
              id: 42,
              op: 'subtract',
              value: 60,
              type: 'years',
            },
            max: {
              id: 43,
              op: 'add',
              value: 1,
              type: 'years',
            },
          },
        },
        validations: [],
        type: 'DATE',
      },
      {
        id: 'firstTimeEmployedInGermany',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 64,
          value: 'Personal',
        },
        screen: {
          id: 108,
          question: t(
            'questionnaire.publicHealthDe.signup.firstTimeEmployedInGermany.screen.question',
            'Is this your first time being employed in Germany?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.firstTimeEmployedInGermany.screen.description',
            'Mini-jobs, student jobs and unpaid internships don’t count.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.firstTimeEmployedInGermany.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'coverageStartDate',
        __component: 'questionnaire.date-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 63,
          value: 'Personal',
        },
        screen: {
          id: 106,
          question: t(
            'questionnaire.publicHealthDe.signup.coverageStartDate.screen.question',
            'When would you like your coverage to start?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.coverageStartDate.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 11,
          yearRange: {
            id: 12,
            min: {
              id: 23,
              op: 'subtract',
              value: 3,
              type: 'years',
            },
            max: {
              id: 24,
              op: 'add',
              value: 1,
              type: 'years',
            },
          },
        },
        validations: [],
        type: 'DATE',
      },
      {
        id: 'universityInGermany',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 104,
          value: 'Personal',
        },
        screen: {
          id: 156,
          question: t(
            'questionnaire.publicHealthDe.signup.universityInGermany.screen.question',
            'Is your university located in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.universityInGermany.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'universityInGermanyBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          id: 157,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.universityInGermanyBlocker.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Standalone',
        },
        props: {
          id: 18,
          title: t(
            'questionnaire.publicHealthDe.signup.universityInGermanyBlocker.props.title',
            'We’re sorry...'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.universityInGermanyBlocker.props.description',
            'We’re sorry, we can’t insure students from universities outside of Germany.\n\nInstead you should sign up for Expat Health Insurance. After you finish your studies and find a job, you can easily switch to Public Health Insurance.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 17,
              caption: t(
                'questionnaire.publicHealthDe.signup.universityInGermanyBlocker.option.0.caption',
                'Learn about expat health'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/health-insurance/expat',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'university',
        __component: 'questionnaire.autosuggest-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 105,
          value: 'Personal',
        },
        screen: {
          id: 158,
          question: t(
            'questionnaire.publicHealthDe.signup.university.screen.question',
            'Which university will you be studying at?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.university.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: {
            id: 11,
            title: t(
              'questionnaire.publicHealthDe.signup.university.screen.skipDetails.title',
              'My university is not listed'
            ),
            path: null,
            skipQuestion: {
              value: '',
            },
          },
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 6,
          externalList: null,
          cmsList: {
            data: {
              id: 1,
              attributes: {
                name: 'publicHealthUniversities',
                createdAt: '2024-12-30T13:22:44.458Z',
                updatedAt: '2025-02-27T16:37:50.922Z',
                publishedAt: '2024-12-30T14:11:49.463Z',
                values: [
                  {
                    id: 1,
                    __component: 'questionnaire.autocomplete-list',
                    autosuggestValues: [
                      'AKAD Hochschule Stuttgart - staatlich anerkannt',
                      'APOLLON Hochschule der Gesundheitswirtschaft',
                      'Akademie der Bildenden Künste München',
                      'Akademie der Bildenden Künste Nürnberg',
                      'Akademie der Polizei Hamburg',
                      'Akkon-Hochschule',
                      'Alanus Hochschule für Kunst und Gesellschaft',
                      'Albert-Ludwigs-Universität Freiburg im Breisgau',
                      'Alice Salomon Hochschule Berlin',
                      'Allensbach Hochschule Konstanz,  staatlich anerkannte Hochschule der European Education Group GmbH',
                      'Archivschule Marburg - Hochschule für Archivwissenschaft',
                      'Augustana-Hochschule Neuendettelsau',
                      'BSP Business and Law School - Hochschule für Management und Recht',
                      'Bard College Berlin, A Liberal Arts University',
                      'Barenboim-Said Akademie',
                      'Bauhaus-Universität Weimar',
                      'Bergische Universität Wuppertal',
                      'Berlin International University of Applied Sciences',
                      'Berliner Hochschule für Technik',
                      'Berufliche Hochschule Hamburg (BHH)',
                      'Brand University of Applied Sciences',
                      'Brandenburgische Technische Universität Cottbus-Senftenberg',
                      'Bucerius Law School, Hochschule für Rechtswissenschaft',
                      'Burg Giebichenstein Kunsthochschule Halle',
                      'CBS International Business School - University of Applied Sciences',
                      'CODE University of Applied Sciences',
                      'CVJM-Hochschule',
                      'Carl von Ossietzky Universität Oldenburg',
                      'Charlotte Fresenius Hochschule',
                      'Christian-Albrechts-Universität zu Kiel',
                      'Constructor University',
                      'DEKRA Hochschule für Medien',
                      'DHGS Deutsche Hochschule für Gesundheit und Sport',
                      'DIPLOMA Hochschule - Private Fachhochschule Nordhessen',
                      'DIU - Dresden International University GmbH',
                      'Deutsche Hochschule der Polizei',
                      'Deutsche Hochschule für Prävention und Gesundheitsmanagement GmbH',
                      'Deutsche Sporthochschule Köln',
                      'Deutsche Universität für Verwaltungswissenschaften Speyer',
                      'Digital Business University of Applied Sciences',
                      'Duale Hochschule Baden-Württemberg',
                      'Duale Hochschule Gera-Eisenach',
                      'Duale Hochschule Schleswig-Holstein - staatlich anerkannte Hochschule für angewandte Wissenschaften in Trägerschaft der Wirtschaftsakademie Schleswig-Holstein',
                      'EBS Universität für Wirtschaft und Recht',
                      'EBZ Business School - University of Applied Sciences',
                      'ESCP Europe Wirtschaftshochschule Berlin e.V.',
                      'ESMT European School of Management and Technology',
                      'Eberhard Karls Universität Tübingen',
                      'Ernst-Abbe-Hochschule Jena - University of Applied Sciences',
                      'Europa-Universität Flensburg',
                      'Europa-Universität Viadrina Frankfurt (Oder)',
                      'Europäische Fachhochschule Rhein/Erft, european university of applied sciences',
                      'Europäische Fernhochschule Hamburg',
                      'Evangelische Hochschule Berlin',
                      'Evangelische Hochschule Darmstadt (staatlich anerkannt) – Kirchliche Körperschaft des öffentlichen Rechts',
                      'Evangelische Hochschule Dresden',
                      'Evangelische Hochschule Freiburg, staatlich anerkannte Hochschule der Evangelischen Landeskirche in Baden',
                      'Evangelische Hochschule Ludwigsburg - staatlich anerkannte Hochschule für Angewandte Wissenschaften der Evangelischen Landeskirche in Württemberg',
                      'Evangelische Hochschule Rheinland-Westfalen-Lippe',
                      'Evangelische Hochschule Tabor',
                      'Evangelische Hochschule für Kirchenmusik',
                      'Evangelische Hochschule für Soziale Arbeit & Diakonie',
                      'Evangelische Hochschule für angewandte Wissenschaften - Evangelische Fachhochschule Nürnberg',
                      'FH Münster University of Applied Sciences',
                      'FOM Hochschule für Oekonomie & Management - University of Applied Sciences',
                      'Fachhochschule Aachen',
                      'Fachhochschule Dortmund',
                      'Fachhochschule Dresden',
                      'Fachhochschule Erfurt',
                      'Fachhochschule Kiel',
                      'Fachhochschule Polizei Sachsen-Anhalt',
                      'Fachhochschule Potsdam',
                      'Fachhochschule Südwestfalen',
                      'Fachhochschule Wedel',
                      'Fachhochschule Westküste, Hochschule für Wirtschaft und Technik',
                      'Fachhochschule der Diakonie - Diaconia - University of Applied Sciences',
                      'Fachhochschule der Polizei Brandenburg',
                      'Fachhochschule der Verwaltung des Saarlandes',
                      'Fachhochschule der Wirtschaft',
                      'Fachhochschule des Mittelstands (FHM)',
                      'Fachhochschule für Finanzen Brandenburg',
                      'Fachhochschule für Interkulturelle Theologie Hermannsburg',
                      'Fachhochschule für Rechtspflege Nordrhein-Westfalen',
                      'Fachhochschule für Sport und Management Potsdam',
                      'Fachhochschule für Verwaltung und Dienstleistung in Schleswig-Holstein',
                      'Fachhochschule für die Wirtschaft Hannover',
                      'Fachhochschule für öffentliche Verwaltung, Polizei und Rechtspflege des Landes Mecklenburg-Vorpommern',
                      'FernUniversität in Hagen',
                      'Filmuniversität Babelsberg Konrad Wolf',
                      'Fliedner Fachhochschule Düsseldorf',
                      'Folkwang Universität der Künste',
                      'Frankfurt School of Finance & Management',
                      'Frankfurt University of Applied Sciences',
                      'Freie Hochschule Stuttgart - Seminar für Waldorfpädagogik. Staatlich anerkannte wissenschaftliche Hochschule.',
                      'Freie Theologische Hochschule Gießen',
                      'Freie Universität Berlin',
                      'Friedrich-Alexander-Universität Erlangen-Nürnberg',
                      'Friedrich-Schiller-Universität Jena',
                      'GISMA Business School',
                      'Georg-August-Universität Göttingen',
                      'Gottfried Wilhelm Leibniz Universität Hannover',
                      'HAWK Hochschule für angewandte Wissenschaft und Kunst Hildesheim/Holzminden/Göttingen',
                      'HHL Leipzig Graduate School of Management',
                      'HMKW Hochschule für Medien, Kommunikation und Wirtschaft',
                      'HMU Health and Medical University',
                      'HSBA Hamburg School of Business Administration',
                      'HSD Hochschule Döpfer',
                      'HafenCity Universität Hamburg',
                      'Hamburger Fern-Hochschule, gemeinnützige GmbH',
                      'Heinrich-Heine-Universität Düsseldorf',
                      'Helmut-Schmidt-Universität/Universität der Bundeswehr Hamburg',
                      'Hertie School',
                      'Hessische Hochschule für Finanzen und Rechtspflege Rotenburg a.d. Fulda',
                      'Hessische Hochschule für öffentliches Management und Sicherheit',
                      'Hochschule  für  angewandte  Wissenschaften  Weihenstephan-Triesdorf',
                      'Hochschule Aalen - Technik und Wirtschaft',
                      'Hochschule Albstadt-Sigmaringen',
                      'Hochschule Anhalt - Anhalt University of Applied Sciences',
                      'Hochschule Biberach - Hochschule für Architektur und Bauwesen, Betriebswirtschaft und Biotechnologie',
                      'Hochschule Bielefeld - University of Applied Sciences and Arts (HSBI)',
                      'Hochschule Bochum - University of Applied Sciences',
                      'Hochschule Bonn-Rhein-Sieg, University of Applied Sciences',
                      'Hochschule Braunschweig/Wolfenbüttel, Ostfalia Hochschule für angewandte Wissenschaften',
                      'Hochschule Bremen',
                      'Hochschule Bremerhaven',
                      'Hochschule Clara Hoffbauer (HCHP) - University of Applied Sciences',
                      'Hochschule Darmstadt',
                      'Hochschule Düsseldorf',
                      'Hochschule Emden/Leer',
                      'Hochschule Esslingen',
                      'Hochschule Flensburg',
                      'Hochschule Fresenius',
                      'Hochschule Fresenius Heidelberg – staatlich anerkannte Hochschule der Hochschule Fresenius für Internationales Management GmbH',
                      'Hochschule Fulda - University of Applied Sciences',
                      'Hochschule Furtwangen - Informatik, Technik, Wirtschaft, Medien, Gesundheit',
                      'Hochschule Geisenheim',
                      'Hochschule Hamm-Lippstadt',
                      'Hochschule Hannover',
                      'Hochschule Harz, Hochschule für angewandte Wissenschaften (FH)',
                      'Hochschule Heilbronn, Technik, Wirtschaft, Informatik',
                      'Hochschule Kaiserslautern (University of Applied Sciences)',
                      'Hochschule Karlsruhe - Technik und Wirtschaft',
                      'Hochschule Koblenz',
                      'Hochschule Konstanz Technik, Wirtschaft und Gestaltung',
                      'Hochschule Landshut - Hochschule für angewandte Wissenschaften',
                      'Hochschule Macromedia - staatlich anerkannte Hochschule für angewandte Wissenschaften der Macromedia GmbH mit Sitz in Stuttgart',
                      'Hochschule Magdeburg-Stendal',
                      'Hochschule Mainz',
                      'Hochschule Mannheim',
                      'Hochschule Merseburg',
                      'Hochschule Mittweida, University of Applied Sciences',
                      'Hochschule Neubrandenburg - University of Applied Sciences',
                      'Hochschule Niederrhein',
                      'Hochschule Nordhausen',
                      'Hochschule Osnabrück',
                      'Hochschule Pforzheim - Gestaltung, Technik, Wirtschaft und Recht',
                      'Hochschule Ravensburg-Weingarten',
                      'Hochschule Reutlingen, Hochschule für Technik-  Wirtschaft-Informatik-Design',
                      'Hochschule Rhein-Waal - University of Applied Sciences',
                      'Hochschule RheinMain',
                      'Hochschule Ruhr West- University of Applied Sciences',
                      'Hochschule Schmalkalden',
                      'Hochschule Stralsund',
                      'Hochschule Trier - Trier University of Applied Sciences',
                      'Hochschule Weserbergland',
                      'Hochschule Wismar - University of Applied Sciences: Technology, Business and Design',
                      'Hochschule Worms, University of Applied Sciences',
                      'Hochschule Zittau/Görlitz',
                      'Hochschule der Bayerischen Wirtschaft für angewandte Wissenschaften - HDBW',
                      'Hochschule der Bildenden Künste Saar',
                      'Hochschule der Bundesagentur für Arbeit - Staatlich anerkannte Hochschule für angewandte Wissenschaft in Mannheim und Schwerin (University of Applied Labour Studies of the Federal Employment Agency)',
                      'Hochschule der Deutschen Bundesbank',
                      'Hochschule der Medien Stuttgart',
                      'Hochschule der Polizei Rheinland-Pfalz',
                      'Hochschule der Sächsischen Polizei (FH)',
                      'Hochschule der Wirtschaft für Management',
                      'Hochschule der bildenden Künste (HBK) Essen',
                      'Hochschule des Bundes für öffentliche Verwaltung',
                      'Hochschule für Angewandte Wissenschaften Hamburg',
                      'Hochschule für Angewandte Wissenschaften Hof',
                      'Hochschule für Bildende Künste (Städelschule)',
                      'Hochschule für Bildende Künste Braunschweig',
                      'Hochschule für Bildende Künste Dresden',
                      'Hochschule für Bildende Künste Hamburg',
                      'Hochschule für Fernsehen und Film München',
                      'Hochschule für Finanzen NRW',
                      'Hochschule für Finanzen Rheinland-Pfalz',
                      'Hochschule für Finanzwirtschaft & Management',
                      'Hochschule für Forstwirtschaft Rottenburg',
                      'Hochschule für Gesellschaftsgestaltung',
                      'Hochschule für Gestaltung Offenbach',
                      'Hochschule für Gestaltung Schwäbisch Gmünd',
                      'Hochschule für Gesundheit - University of Applied Sciences',
                      'Hochschule für Grafik und Buchkunst Leipzig',
                      'Hochschule für Jüdische Studien Heidelberg',
                      'Hochschule für Katholische Kirchenmusik und Musikpädagogik',
                      'Hochschule für Kirchenmusik der Diözese Rottenburg-Stuttgart',
                      'Hochschule für Kirchenmusik der Evangelisch-Lutherischen Landeskirche Sachsens',
                      'Hochschule für Kirchenmusik der Evangelischen Kirche von Westfalen',
                      'Hochschule für Kirchenmusik der Evangelischen Landeskirche in Baden',
                      'Hochschule für Kirchenmusik der Evangelischen Landeskirche in Württemberg',
                      'Hochschule für Kommunikation und Gestaltung',
                      'Hochschule für Künste Bremen',
                      'Hochschule für Künste im Sozialen, Ottersberg',
                      'Hochschule für Musik Carl Maria von Weber Dresden',
                      'Hochschule für Musik Detmold',
                      'Hochschule für Musik Franz Liszt Weimar',
                      'Hochschule für Musik Freiburg im Breisgau',
                      'Hochschule für Musik Hanns Eisler Berlin',
                      'Hochschule für Musik Karlsruhe',
                      'Hochschule für Musik Nürnberg',
                      'Hochschule für Musik Saar',
                      'Hochschule für Musik Würzburg',
                      'Hochschule für Musik und Darstellende Kunst Frankfurt am Main',
                      'Hochschule für Musik und Tanz Köln',
                      'Hochschule für Musik und Theater Felix Mendelssohn Bartholdy Leipzig',
                      'Hochschule für Musik und Theater Hamburg',
                      'Hochschule für Musik und Theater München',
                      'Hochschule für Musik und Theater Rostock',
                      'Hochschule für Musik, Theater und Medien Hannover',
                      'Hochschule für Philosophie',
                      'Hochschule für Polizei Baden-Württemberg',
                      'Hochschule für Polizei und öffentliche Verwaltung Nordrhein-Westfalen',
                      'Hochschule für Rechtspflege Schwetzingen',
                      'Hochschule für Schauspielkunst Ernst Busch',
                      'Hochschule für Technik Stuttgart',
                      'Hochschule für Technik und Wirtschaft Berlin',
                      'Hochschule für Technik und Wirtschaft Dresden - University of Applied Sciences',
                      'Hochschule für Technik und Wirtschaft des Saarlandes',
                      'Hochschule für Technik, Wirtschaft und Kultur Leipzig',
                      'Hochschule für Technik, Wirtschaft und Medien Offenburg',
                      'Hochschule für Wirtschaft und Gesellschaft Ludwigshafen ',
                      'Hochschule für Wirtschaft und Recht Berlin',
                      'Hochschule für Wirtschaft und Umwelt Nürtingen-Geislingen',
                      'Hochschule für angewandte Pädagogik',
                      'Hochschule für angewandte Wissenschaften Ansbach',
                      'Hochschule für angewandte Wissenschaften Augsburg - University of Applied Sciences',
                      'Hochschule für angewandte Wissenschaften Coburg',
                      'Hochschule für angewandte Wissenschaften Kempten',
                      'Hochschule für angewandte Wissenschaften München',
                      'Hochschule für angewandte Wissenschaften Neu-Ulm',
                      'Hochschule für angewandtes Management',
                      'Hochschule für den öffentlichen Dienst in Bayern',
                      'Hochschule für evangelische Kirchenmusik der Evangelisch-Lutherischen Kirche in Bayern',
                      'Hochschule für nachhaltige Entwicklung Eberswalde',
                      'Hochschule für Öffentliche Verwaltung Bremen',
                      'Hochschule für öffentliche Verwaltung Kehl',
                      'Hochschule für öffentliche Verwaltung Rheinland-Pfalz',
                      'Hochschule für öffentliche Verwaltung und Finanzen Ludwigsburg',
                      'Hochschule für öffentliche Verwaltung und Rechtspflege (FH), Fortbildungszentrum des Freistaates Sachsen',
                      'Humboldt-Universität zu Berlin',
                      'IB Hochschule für Gesundheit und Soziales',
                      'IST-Hochschule für Management',
                      'IU Internationale Hochschule',
                      'International Psychoanalytic University Berlin',
                      'International School of Management',
                      'Internationale Hochschule Liebenzell (IHL)',
                      'Internationale Hochschule SDI München - Hochschule für angewandte Wissenschaften',
                      'Jade Hochschule -  Wilhelmshaven/Oldenburg/Elsfleth',
                      'Johann Wolfgang Goethe-Universität, Frankfurt am Main',
                      'Johannes Gutenberg-Universität Mainz',
                      'Julius-Maximilians-Universität Würzburg',
                      'Justus-Liebig-Universität Gießen',
                      'Karlshochschule International University - staatlich anerkannte Hochschule der Karlshochschule gemeinnützige GmbH Karlsruhe',
                      'Karlsruher Institut für Technologie',
                      'Katholische    Stiftungshochschule für   angewandte Wissenschaften München - Hochschule der Kirchlichen Stiftung des öffentlichen Rechts Katholische Bildungsstätten für Sozialberufe in Bayern',
                      'Katholische Hochschule Freiburg, staatlich anerkannte Hochschule - Catholic University of Applied Sciences',
                      'Katholische Hochschule Mainz Catholic University of Applied Sciences',
                      'Katholische Hochschule Nordrhein-Westfalen - Catholic University of Applied Sciences',
                      'Katholische Hochschule für Sozialwesen Berlin (KHSB) - Staatlich anerkannte Fachhochschule für Sozialwesen',
                      'Katholische Universität Eichstätt - Ingolstadt',
                      'Kirchliche Hochschule Wuppertal',
                      'Kolping Hochschule',
                      'Kommunale Hochschule für Verwaltung in Niedersachsen',
                      'Kunstakademie Düsseldorf',
                      'Kunstakademie Münster, Hochschule für Bildende Künste',
                      'Kunsthochschule für Medien Köln',
                      'Kölner Hochschule für Katholische Theologie (KHKT)',
                      'Kühne Logistics University - Wissenschaftliche Hochschule für Logistik und Unternehmensführung',
                      'Leibniz-Fachhochschule',
                      'Leuphana Universität Lüneburg',
                      'Ludwig-Maximilians-Universität München',
                      'Lutherische Theologische Hochschule Oberursel',
                      'MSH Medical School Hamburg - University of Applied Sciences and Medical University',
                      'Martin-Luther-Universität Halle-Wittenberg',
                      'Mediadesign Hochschule für Design und Informatik',
                      'Medical School Berlin - Hochschule für Gesundheit und Medizin (MSB)',
                      'Medizinische Hochschule Brandenburg Theodor Fontane',
                      'Medizinische Hochschule Hannover (MHH)',
                      'Merz Akademie Hochschule für Gestaltung, Kunst und Medien, Stuttgart - Staatlich anerkannt',
                      'Munich Business School - Staatlich anerkannte private Fachhochschule',
                      'Musikhochschule Lübeck',
                      'Muthesius Kunsthochschule',
                      'NBS Northern Business School – University of Applied Sciences',
                      'Nordakademie - Staatlich anerkannte private Fachhochschule mit dualen Studiengängen',
                      'Norddeutsche Akademie für Finanzen und Steuerrecht',
                      'Norddeutsche Hochschule für Rechtspflege - Niedersachsen',
                      'Ostbayerische Technische Hochschule Amberg-Weiden',
                      'Ostbayerische Technische Hochschule Regensburg',
                      'Otto-Friedrich-Universität Bamberg',
                      'Otto-von-Guericke-Universität Magdeburg',
                      'PFH - Private Hochschule Göttingen',
                      'Palucca Hochschule für Tanz Dresden',
                      'Philipps-Universität Marburg',
                      'Philosophisch-Theologische Hochschule Münster - Kirchlich und staatlich anerkannte Hochschule in Trägerschaft der PTH Philosophisch-Theologische Hochschule Münster gemeinnützige GmbH',
                      'Philosophisch-Theologische Hochschule Sankt Georgen Frankfurt am Main',
                      'Polizeiakademie Niedersachsen',
                      'Private Hochschule für Wirtschaft und Technik Vechta/Diepholz',
                      'Private Universität Witten/Herdecke gGmbH',
                      'Provadis School of International Management and Technology',
                      'Psychologische Hochschule Berlin (PHB)',
                      'Pädagogische Hochschule Freiburg',
                      'Pädagogische Hochschule Heidelberg',
                      'Pädagogische Hochschule Karlsruhe',
                      'Pädagogische Hochschule Ludwigsburg',
                      'Pädagogische Hochschule Schwäbisch Gmünd',
                      'Pädagogische Hochschule Weingarten',
                      'Quadriga Hochschule Berlin',
                      'Rheinisch-Westfälische Technische Hochschule Aachen',
                      'Rheinische Fachhochschule Köln',
                      'Rheinische Friedrich-Wilhelms-Universität Bonn',
                      'Rheinland-Pfälzische Technische Universität Kaiserslautern-Landau',
                      'Robert-Schumann-Hochschule Düsseldorf',
                      'Ruhr-Universität Bochum',
                      'Ruprecht-Karls-Universität Heidelberg',
                      'SRH Berlin University of Applied Sciences',
                      'SRH Fernhochschule - The Mobile University',
                      'SRH Hochschule Heidelberg - Staatlich anerkannte Fachhochschule',
                      'SRH Hochschule für Gesundheit',
                      'SRH Hochschule in Nordrhein-Westfalen',
                      'SRH Wilhelm Löhe Hochschule',
                      'Staatliche Akademie der Bildenden Künste Karlsruhe',
                      'Staatliche Akademie der Bildenden Künste Stuttgart',
                      'Staatliche Hochschule für Gestaltung Karlsruhe',
                      'Staatliche Hochschule für Musik Trossingen',
                      'Staatliche Hochschule für Musik und Darstellende Kunst Mannheim',
                      'Staatliche Hochschule für Musik und Darstellende Kunst Stuttgart',
                      'Steinbeis-Hochschule',
                      'Steuerakademie Niedersachsen',
                      'Stiftung Tierärztliche Hochschule Hannover',
                      'Technische Hochschule Aschaffenburg',
                      'Technische Hochschule Bingen',
                      'Technische Hochschule Brandenburg',
                      'Technische Hochschule Deggendorf',
                      'Technische Hochschule Georg Agricola',
                      'Technische Hochschule Ingolstadt',
                      'Technische Hochschule Köln',
                      'Technische Hochschule Lübeck',
                      'Technische Hochschule Mittelhessen - THM',
                      'Technische Hochschule Nürnberg Georg Simon Ohm',
                      'Technische Hochschule Ostwestfalen-Lippe ',
                      'Technische Hochschule Rosenheim',
                      'Technische Hochschule Ulm',
                      'Technische Hochschule Wildau',
                      'Technische Hochschule Würzburg-Schweinfurt',
                      'Technische Universität Bergakademie Freiberg',
                      'Technische Universität Berlin',
                      'Technische Universität Carolo-Wilhelmina zu Braunschweig',
                      'Technische Universität Chemnitz',
                      'Technische Universität Clausthal',
                      'Technische Universität Darmstadt',
                      'Technische Universität Dortmund',
                      'Technische Universität Dresden',
                      'Technische Universität Hamburg',
                      'Technische Universität Ilmenau',
                      'Technische Universität München',
                      'Theologische Fakultät Fulda',
                      'Theologische Fakultät Paderborn',
                      'Theologische Fakultät Trier',
                      'Theologische Hochschule Elstal',
                      'Theologische Hochschule Friedensau',
                      'Theologische Hochschule Reutlingen - staatlich anerkannte Fachhochschule der Evangelisch-methodistischen Kirche',
                      'Theologisches Hochschule Ewersbach',
                      'Thüringer Fachhochschule für öffentliche Verwaltung',
                      'Touro College Berlin',
                      'University of Europe for Applied Sciences',
                      'University of Labour',
                      'Universität Augsburg',
                      'Universität Bayreuth',
                      'Universität Bielefeld',
                      'Universität Bremen',
                      'Universität Duisburg-Essen',
                      'Universität Erfurt',
                      'Universität Greifswald',
                      'Universität Hamburg',
                      'Universität Hildesheim',
                      'Universität Hohenheim',
                      'Universität Kassel',
                      'Universität Koblenz',
                      'Universität Konstanz',
                      'Universität Leipzig',
                      'Universität Mannheim',
                      'Universität Osnabrück',
                      'Universität Paderborn',
                      'Universität Passau',
                      'Universität Potsdam',
                      'Universität Regensburg',
                      'Universität Rostock',
                      'Universität Siegen',
                      'Universität Stuttgart',
                      'Universität Trier',
                      'Universität Ulm',
                      'Universität Vechta',
                      'Universität der Bundeswehr München',
                      'Universität der Künste Berlin',
                      'Universität des Saarlandes',
                      'Universität zu Köln',
                      'Universität zu Lübeck',
                      'VICTORIA | Internationale Hochschule',
                      'VWA-Hochschule für berufsbegleitendes Studium',
                      'Vinzenz Pallotti University',
                      'WHU - Otto Beisheim School of Management',
                      'Westfälische Hochschule Gelsenkirchen, Bocholt, Recklinghausen',
                      'Westfälische Wilhelms-Universität Münster',
                      'Westsächsische Hochschule Zwickau',
                      'Wilhelm Büchner Hochschule - Private Fernhochschule Darmstadt',
                      'XU Exponential University of Applied Sciences',
                      'Zeppelin Universität - Hochschule zwischen Wirtschaft, Kultur und Politik',
                      'accadis Hochschule Bad Homburg',
                      'bbw Hochschule',
                      'hochschule 21',
                      'media Akademie - Hochschule Stuttgart',
                      'weißensee kunsthochschule berlin',
                    ],
                  },
                ],
              },
            },
          },
          options: [
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.0',
              'AKAD Hochschule Stuttgart - staatlich anerkannt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.1',
              'APOLLON Hochschule der Gesundheitswirtschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.2',
              'Akademie der Bildenden Künste München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.3',
              'Akademie der Bildenden Künste Nürnberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.4',
              'Akademie der Polizei Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.5',
              'Akkon-Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.6',
              'Alanus Hochschule für Kunst und Gesellschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.7',
              'Albert-Ludwigs-Universität Freiburg im Breisgau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.8',
              'Alice Salomon Hochschule Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.9',
              'Allensbach Hochschule Konstanz,  staatlich anerkannte Hochschule der European Education Group GmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.10',
              'Archivschule Marburg - Hochschule für Archivwissenschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.11',
              'Augustana-Hochschule Neuendettelsau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.12',
              'BSP Business and Law School - Hochschule für Management und Recht'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.13',
              'Bard College Berlin, A Liberal Arts University'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.14',
              'Barenboim-Said Akademie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.15',
              'Bauhaus-Universität Weimar'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.16',
              'Bergische Universität Wuppertal'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.17',
              'Berlin International University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.18',
              'Berliner Hochschule für Technik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.19',
              'Berufliche Hochschule Hamburg (BHH)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.20',
              'Brand University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.21',
              'Brandenburgische Technische Universität Cottbus-Senftenberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.22',
              'Bucerius Law School, Hochschule für Rechtswissenschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.23',
              'Burg Giebichenstein Kunsthochschule Halle'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.24',
              'CBS International Business School - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.25',
              'CODE University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.26',
              'CVJM-Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.27',
              'Carl von Ossietzky Universität Oldenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.28',
              'Charlotte Fresenius Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.29',
              'Christian-Albrechts-Universität zu Kiel'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.30',
              'Constructor University'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.31',
              'DEKRA Hochschule für Medien'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.32',
              'DHGS Deutsche Hochschule für Gesundheit und Sport'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.33',
              'DIPLOMA Hochschule - Private Fachhochschule Nordhessen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.34',
              'DIU - Dresden International University GmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.35',
              'Deutsche Hochschule der Polizei'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.36',
              'Deutsche Hochschule für Prävention und Gesundheitsmanagement GmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.37',
              'Deutsche Sporthochschule Köln'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.38',
              'Deutsche Universität für Verwaltungswissenschaften Speyer'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.39',
              'Digital Business University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.40',
              'Duale Hochschule Baden-Württemberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.41',
              'Duale Hochschule Gera-Eisenach'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.42',
              'Duale Hochschule Schleswig-Holstein - staatlich anerkannte Hochschule für angewandte Wissenschaften in Trägerschaft der Wirtschaftsakademie Schleswig-Holstein'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.43',
              'EBS Universität für Wirtschaft und Recht'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.44',
              'EBZ Business School - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.45',
              'ESCP Europe Wirtschaftshochschule Berlin e.V.'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.46',
              'ESMT European School of Management and Technology'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.47',
              'Eberhard Karls Universität Tübingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.48',
              'Ernst-Abbe-Hochschule Jena - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.49',
              'Europa-Universität Flensburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.50',
              'Europa-Universität Viadrina Frankfurt (Oder)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.51',
              'Europäische Fachhochschule Rhein/Erft, european university of applied sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.52',
              'Europäische Fernhochschule Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.53',
              'Evangelische Hochschule Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.54',
              'Evangelische Hochschule Darmstadt (staatlich anerkannt) – Kirchliche Körperschaft des öffentlichen Rechts'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.55',
              'Evangelische Hochschule Dresden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.56',
              'Evangelische Hochschule Freiburg, staatlich anerkannte Hochschule der Evangelischen Landeskirche in Baden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.57',
              'Evangelische Hochschule Ludwigsburg - staatlich anerkannte Hochschule für Angewandte Wissenschaften der Evangelischen Landeskirche in Württemberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.58',
              'Evangelische Hochschule Rheinland-Westfalen-Lippe'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.59',
              'Evangelische Hochschule Tabor'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.60',
              'Evangelische Hochschule für Kirchenmusik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.61',
              'Evangelische Hochschule für Soziale Arbeit & Diakonie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.62',
              'Evangelische Hochschule für angewandte Wissenschaften - Evangelische Fachhochschule Nürnberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.63',
              'FH Münster University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.64',
              'FOM Hochschule für Oekonomie & Management - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.65',
              'Fachhochschule Aachen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.66',
              'Fachhochschule Dortmund'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.67',
              'Fachhochschule Dresden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.68',
              'Fachhochschule Erfurt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.69',
              'Fachhochschule Kiel'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.70',
              'Fachhochschule Polizei Sachsen-Anhalt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.71',
              'Fachhochschule Potsdam'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.72',
              'Fachhochschule Südwestfalen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.73',
              'Fachhochschule Wedel'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.74',
              'Fachhochschule Westküste, Hochschule für Wirtschaft und Technik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.75',
              'Fachhochschule der Diakonie - Diaconia - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.76',
              'Fachhochschule der Polizei Brandenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.77',
              'Fachhochschule der Verwaltung des Saarlandes'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.78',
              'Fachhochschule der Wirtschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.79',
              'Fachhochschule des Mittelstands (FHM)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.80',
              'Fachhochschule für Finanzen Brandenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.81',
              'Fachhochschule für Interkulturelle Theologie Hermannsburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.82',
              'Fachhochschule für Rechtspflege Nordrhein-Westfalen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.83',
              'Fachhochschule für Sport und Management Potsdam'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.84',
              'Fachhochschule für Verwaltung und Dienstleistung in Schleswig-Holstein'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.85',
              'Fachhochschule für die Wirtschaft Hannover'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.86',
              'Fachhochschule für öffentliche Verwaltung, Polizei und Rechtspflege des Landes Mecklenburg-Vorpommern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.87',
              'FernUniversität in Hagen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.88',
              'Filmuniversität Babelsberg Konrad Wolf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.89',
              'Fliedner Fachhochschule Düsseldorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.90',
              'Folkwang Universität der Künste'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.91',
              'Frankfurt School of Finance & Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.92',
              'Frankfurt University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.93',
              'Freie Hochschule Stuttgart - Seminar für Waldorfpädagogik. Staatlich anerkannte wissenschaftliche Hochschule.'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.94',
              'Freie Theologische Hochschule Gießen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.95',
              'Freie Universität Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.96',
              'Friedrich-Alexander-Universität Erlangen-Nürnberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.97',
              'Friedrich-Schiller-Universität Jena'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.98',
              'GISMA Business School'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.99',
              'Georg-August-Universität Göttingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.100',
              'Gottfried Wilhelm Leibniz Universität Hannover'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.101',
              'HAWK Hochschule für angewandte Wissenschaft und Kunst Hildesheim/Holzminden/Göttingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.102',
              'HHL Leipzig Graduate School of Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.103',
              'HMKW Hochschule für Medien, Kommunikation und Wirtschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.104',
              'HMU Health and Medical University'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.105',
              'HSBA Hamburg School of Business Administration'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.106',
              'HSD Hochschule Döpfer'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.107',
              'HafenCity Universität Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.108',
              'Hamburger Fern-Hochschule, gemeinnützige GmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.109',
              'Heinrich-Heine-Universität Düsseldorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.110',
              'Helmut-Schmidt-Universität/Universität der Bundeswehr Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.111',
              'Hertie School'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.112',
              'Hessische Hochschule für Finanzen und Rechtspflege Rotenburg a.d. Fulda'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.113',
              'Hessische Hochschule für öffentliches Management und Sicherheit'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.114',
              'Hochschule  für  angewandte  Wissenschaften  Weihenstephan-Triesdorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.115',
              'Hochschule Aalen - Technik und Wirtschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.116',
              'Hochschule Albstadt-Sigmaringen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.117',
              'Hochschule Anhalt - Anhalt University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.118',
              'Hochschule Biberach - Hochschule für Architektur und Bauwesen, Betriebswirtschaft und Biotechnologie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.119',
              'Hochschule Bielefeld - University of Applied Sciences and Arts (HSBI)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.120',
              'Hochschule Bochum - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.121',
              'Hochschule Bonn-Rhein-Sieg, University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.122',
              'Hochschule Braunschweig/Wolfenbüttel, Ostfalia Hochschule für angewandte Wissenschaften'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.123',
              'Hochschule Bremen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.124',
              'Hochschule Bremerhaven'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.125',
              'Hochschule Clara Hoffbauer (HCHP) - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.126',
              'Hochschule Darmstadt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.127',
              'Hochschule Düsseldorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.128',
              'Hochschule Emden/Leer'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.129',
              'Hochschule Esslingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.130',
              'Hochschule Flensburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.131',
              'Hochschule Fresenius'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.132',
              'Hochschule Fresenius Heidelberg – staatlich anerkannte Hochschule der Hochschule Fresenius für Internationales Management GmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.133',
              'Hochschule Fulda - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.134',
              'Hochschule Furtwangen - Informatik, Technik, Wirtschaft, Medien, Gesundheit'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.135',
              'Hochschule Geisenheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.136',
              'Hochschule Hamm-Lippstadt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.137',
              'Hochschule Hannover'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.138',
              'Hochschule Harz, Hochschule für angewandte Wissenschaften (FH)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.139',
              'Hochschule Heilbronn, Technik, Wirtschaft, Informatik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.140',
              'Hochschule Kaiserslautern (University of Applied Sciences)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.141',
              'Hochschule Karlsruhe - Technik und Wirtschaft'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.142',
              'Hochschule Koblenz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.143',
              'Hochschule Konstanz Technik, Wirtschaft und Gestaltung'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.144',
              'Hochschule Landshut - Hochschule für angewandte Wissenschaften'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.145',
              'Hochschule Macromedia - staatlich anerkannte Hochschule für angewandte Wissenschaften der Macromedia GmbH mit Sitz in Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.146',
              'Hochschule Magdeburg-Stendal'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.147',
              'Hochschule Mainz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.148',
              'Hochschule Mannheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.149',
              'Hochschule Merseburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.150',
              'Hochschule Mittweida, University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.151',
              'Hochschule Neubrandenburg - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.152',
              'Hochschule Niederrhein'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.153',
              'Hochschule Nordhausen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.154',
              'Hochschule Osnabrück'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.155',
              'Hochschule Pforzheim - Gestaltung, Technik, Wirtschaft und Recht'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.156',
              'Hochschule Ravensburg-Weingarten'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.157',
              'Hochschule Reutlingen, Hochschule für Technik-  Wirtschaft-Informatik-Design'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.158',
              'Hochschule Rhein-Waal - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.159',
              'Hochschule RheinMain'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.160',
              'Hochschule Ruhr West- University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.161',
              'Hochschule Schmalkalden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.162',
              'Hochschule Stralsund'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.163',
              'Hochschule Trier - Trier University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.164',
              'Hochschule Weserbergland'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.165',
              'Hochschule Wismar - University of Applied Sciences: Technology, Business and Design'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.166',
              'Hochschule Worms, University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.167',
              'Hochschule Zittau/Görlitz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.168',
              'Hochschule der Bayerischen Wirtschaft für angewandte Wissenschaften - HDBW'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.169',
              'Hochschule der Bildenden Künste Saar'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.170',
              'Hochschule der Bundesagentur für Arbeit - Staatlich anerkannte Hochschule für angewandte Wissenschaft in Mannheim und Schwerin (University of Applied Labour Studies of the Federal Employment Agency)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.171',
              'Hochschule der Deutschen Bundesbank'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.172',
              'Hochschule der Medien Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.173',
              'Hochschule der Polizei Rheinland-Pfalz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.174',
              'Hochschule der Sächsischen Polizei (FH)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.175',
              'Hochschule der Wirtschaft für Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.176',
              'Hochschule der bildenden Künste (HBK) Essen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.177',
              'Hochschule des Bundes für öffentliche Verwaltung'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.178',
              'Hochschule für Angewandte Wissenschaften Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.179',
              'Hochschule für Angewandte Wissenschaften Hof'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.180',
              'Hochschule für Bildende Künste (Städelschule)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.181',
              'Hochschule für Bildende Künste Braunschweig'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.182',
              'Hochschule für Bildende Künste Dresden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.183',
              'Hochschule für Bildende Künste Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.184',
              'Hochschule für Fernsehen und Film München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.185',
              'Hochschule für Finanzen NRW'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.186',
              'Hochschule für Finanzen Rheinland-Pfalz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.187',
              'Hochschule für Finanzwirtschaft & Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.188',
              'Hochschule für Forstwirtschaft Rottenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.189',
              'Hochschule für Gesellschaftsgestaltung'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.190',
              'Hochschule für Gestaltung Offenbach'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.191',
              'Hochschule für Gestaltung Schwäbisch Gmünd'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.192',
              'Hochschule für Gesundheit - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.193',
              'Hochschule für Grafik und Buchkunst Leipzig'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.194',
              'Hochschule für Jüdische Studien Heidelberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.195',
              'Hochschule für Katholische Kirchenmusik und Musikpädagogik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.196',
              'Hochschule für Kirchenmusik der Diözese Rottenburg-Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.197',
              'Hochschule für Kirchenmusik der Evangelisch-Lutherischen Landeskirche Sachsens'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.198',
              'Hochschule für Kirchenmusik der Evangelischen Kirche von Westfalen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.199',
              'Hochschule für Kirchenmusik der Evangelischen Landeskirche in Baden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.200',
              'Hochschule für Kirchenmusik der Evangelischen Landeskirche in Württemberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.201',
              'Hochschule für Kommunikation und Gestaltung'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.202',
              'Hochschule für Künste Bremen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.203',
              'Hochschule für Künste im Sozialen, Ottersberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.204',
              'Hochschule für Musik Carl Maria von Weber Dresden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.205',
              'Hochschule für Musik Detmold'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.206',
              'Hochschule für Musik Franz Liszt Weimar'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.207',
              'Hochschule für Musik Freiburg im Breisgau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.208',
              'Hochschule für Musik Hanns Eisler Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.209',
              'Hochschule für Musik Karlsruhe'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.210',
              'Hochschule für Musik Nürnberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.211',
              'Hochschule für Musik Saar'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.212',
              'Hochschule für Musik Würzburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.213',
              'Hochschule für Musik und Darstellende Kunst Frankfurt am Main'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.214',
              'Hochschule für Musik und Tanz Köln'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.215',
              'Hochschule für Musik und Theater Felix Mendelssohn Bartholdy Leipzig'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.216',
              'Hochschule für Musik und Theater Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.217',
              'Hochschule für Musik und Theater München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.218',
              'Hochschule für Musik und Theater Rostock'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.219',
              'Hochschule für Musik, Theater und Medien Hannover'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.220',
              'Hochschule für Philosophie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.221',
              'Hochschule für Polizei Baden-Württemberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.222',
              'Hochschule für Polizei und öffentliche Verwaltung Nordrhein-Westfalen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.223',
              'Hochschule für Rechtspflege Schwetzingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.224',
              'Hochschule für Schauspielkunst Ernst Busch'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.225',
              'Hochschule für Technik Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.226',
              'Hochschule für Technik und Wirtschaft Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.227',
              'Hochschule für Technik und Wirtschaft Dresden - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.228',
              'Hochschule für Technik und Wirtschaft des Saarlandes'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.229',
              'Hochschule für Technik, Wirtschaft und Kultur Leipzig'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.230',
              'Hochschule für Technik, Wirtschaft und Medien Offenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.231',
              'Hochschule für Wirtschaft und Gesellschaft Ludwigshafen '
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.232',
              'Hochschule für Wirtschaft und Recht Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.233',
              'Hochschule für Wirtschaft und Umwelt Nürtingen-Geislingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.234',
              'Hochschule für angewandte Pädagogik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.235',
              'Hochschule für angewandte Wissenschaften Ansbach'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.236',
              'Hochschule für angewandte Wissenschaften Augsburg - University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.237',
              'Hochschule für angewandte Wissenschaften Coburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.238',
              'Hochschule für angewandte Wissenschaften Kempten'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.239',
              'Hochschule für angewandte Wissenschaften München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.240',
              'Hochschule für angewandte Wissenschaften Neu-Ulm'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.241',
              'Hochschule für angewandtes Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.242',
              'Hochschule für den öffentlichen Dienst in Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.243',
              'Hochschule für evangelische Kirchenmusik der Evangelisch-Lutherischen Kirche in Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.244',
              'Hochschule für nachhaltige Entwicklung Eberswalde'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.245',
              'Hochschule für Öffentliche Verwaltung Bremen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.246',
              'Hochschule für öffentliche Verwaltung Kehl'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.247',
              'Hochschule für öffentliche Verwaltung Rheinland-Pfalz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.248',
              'Hochschule für öffentliche Verwaltung und Finanzen Ludwigsburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.249',
              'Hochschule für öffentliche Verwaltung und Rechtspflege (FH), Fortbildungszentrum des Freistaates Sachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.250',
              'Humboldt-Universität zu Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.251',
              'IB Hochschule für Gesundheit und Soziales'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.252',
              'IST-Hochschule für Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.253',
              'IU Internationale Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.254',
              'International Psychoanalytic University Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.255',
              'International School of Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.256',
              'Internationale Hochschule Liebenzell (IHL)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.257',
              'Internationale Hochschule SDI München - Hochschule für angewandte Wissenschaften'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.258',
              'Jade Hochschule -  Wilhelmshaven/Oldenburg/Elsfleth'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.259',
              'Johann Wolfgang Goethe-Universität, Frankfurt am Main'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.260',
              'Johannes Gutenberg-Universität Mainz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.261',
              'Julius-Maximilians-Universität Würzburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.262',
              'Justus-Liebig-Universität Gießen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.263',
              'Karlshochschule International University - staatlich anerkannte Hochschule der Karlshochschule gemeinnützige GmbH Karlsruhe'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.264',
              'Karlsruher Institut für Technologie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.265',
              'Katholische    Stiftungshochschule für   angewandte Wissenschaften München - Hochschule der Kirchlichen Stiftung des öffentlichen Rechts Katholische Bildungsstätten für Sozialberufe in Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.266',
              'Katholische Hochschule Freiburg, staatlich anerkannte Hochschule - Catholic University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.267',
              'Katholische Hochschule Mainz Catholic University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.268',
              'Katholische Hochschule Nordrhein-Westfalen - Catholic University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.269',
              'Katholische Hochschule für Sozialwesen Berlin (KHSB) - Staatlich anerkannte Fachhochschule für Sozialwesen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.270',
              'Katholische Universität Eichstätt - Ingolstadt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.271',
              'Kirchliche Hochschule Wuppertal'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.272',
              'Kolping Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.273',
              'Kommunale Hochschule für Verwaltung in Niedersachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.274',
              'Kunstakademie Düsseldorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.275',
              'Kunstakademie Münster, Hochschule für Bildende Künste'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.276',
              'Kunsthochschule für Medien Köln'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.277',
              'Kölner Hochschule für Katholische Theologie (KHKT)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.278',
              'Kühne Logistics University - Wissenschaftliche Hochschule für Logistik und Unternehmensführung'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.279',
              'Leibniz-Fachhochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.280',
              'Leuphana Universität Lüneburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.281',
              'Ludwig-Maximilians-Universität München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.282',
              'Lutherische Theologische Hochschule Oberursel'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.283',
              'MSH Medical School Hamburg - University of Applied Sciences and Medical University'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.284',
              'Martin-Luther-Universität Halle-Wittenberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.285',
              'Mediadesign Hochschule für Design und Informatik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.286',
              'Medical School Berlin - Hochschule für Gesundheit und Medizin (MSB)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.287',
              'Medizinische Hochschule Brandenburg Theodor Fontane'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.288',
              'Medizinische Hochschule Hannover (MHH)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.289',
              'Merz Akademie Hochschule für Gestaltung, Kunst und Medien, Stuttgart - Staatlich anerkannt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.290',
              'Munich Business School - Staatlich anerkannte private Fachhochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.291',
              'Musikhochschule Lübeck'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.292',
              'Muthesius Kunsthochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.293',
              'NBS Northern Business School – University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.294',
              'Nordakademie - Staatlich anerkannte private Fachhochschule mit dualen Studiengängen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.295',
              'Norddeutsche Akademie für Finanzen und Steuerrecht'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.296',
              'Norddeutsche Hochschule für Rechtspflege - Niedersachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.297',
              'Ostbayerische Technische Hochschule Amberg-Weiden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.298',
              'Ostbayerische Technische Hochschule Regensburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.299',
              'Otto-Friedrich-Universität Bamberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.300',
              'Otto-von-Guericke-Universität Magdeburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.301',
              'PFH - Private Hochschule Göttingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.302',
              'Palucca Hochschule für Tanz Dresden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.303',
              'Philipps-Universität Marburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.304',
              'Philosophisch-Theologische Hochschule Münster - Kirchlich und staatlich anerkannte Hochschule in Trägerschaft der PTH Philosophisch-Theologische Hochschule Münster gemeinnützige GmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.305',
              'Philosophisch-Theologische Hochschule Sankt Georgen Frankfurt am Main'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.306',
              'Polizeiakademie Niedersachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.307',
              'Private Hochschule für Wirtschaft und Technik Vechta/Diepholz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.308',
              'Private Universität Witten/Herdecke gGmbH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.309',
              'Provadis School of International Management and Technology'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.310',
              'Psychologische Hochschule Berlin (PHB)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.311',
              'Pädagogische Hochschule Freiburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.312',
              'Pädagogische Hochschule Heidelberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.313',
              'Pädagogische Hochschule Karlsruhe'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.314',
              'Pädagogische Hochschule Ludwigsburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.315',
              'Pädagogische Hochschule Schwäbisch Gmünd'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.316',
              'Pädagogische Hochschule Weingarten'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.317',
              'Quadriga Hochschule Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.318',
              'Rheinisch-Westfälische Technische Hochschule Aachen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.319',
              'Rheinische Fachhochschule Köln'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.320',
              'Rheinische Friedrich-Wilhelms-Universität Bonn'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.321',
              'Rheinland-Pfälzische Technische Universität Kaiserslautern-Landau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.322',
              'Robert-Schumann-Hochschule Düsseldorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.323',
              'Ruhr-Universität Bochum'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.324',
              'Ruprecht-Karls-Universität Heidelberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.325',
              'SRH Berlin University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.326',
              'SRH Fernhochschule - The Mobile University'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.327',
              'SRH Hochschule Heidelberg - Staatlich anerkannte Fachhochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.328',
              'SRH Hochschule für Gesundheit'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.329',
              'SRH Hochschule in Nordrhein-Westfalen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.330',
              'SRH Wilhelm Löhe Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.331',
              'Staatliche Akademie der Bildenden Künste Karlsruhe'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.332',
              'Staatliche Akademie der Bildenden Künste Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.333',
              'Staatliche Hochschule für Gestaltung Karlsruhe'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.334',
              'Staatliche Hochschule für Musik Trossingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.335',
              'Staatliche Hochschule für Musik und Darstellende Kunst Mannheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.336',
              'Staatliche Hochschule für Musik und Darstellende Kunst Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.337',
              'Steinbeis-Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.338',
              'Steuerakademie Niedersachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.339',
              'Stiftung Tierärztliche Hochschule Hannover'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.340',
              'Technische Hochschule Aschaffenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.341',
              'Technische Hochschule Bingen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.342',
              'Technische Hochschule Brandenburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.343',
              'Technische Hochschule Deggendorf'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.344',
              'Technische Hochschule Georg Agricola'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.345',
              'Technische Hochschule Ingolstadt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.346',
              'Technische Hochschule Köln'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.347',
              'Technische Hochschule Lübeck'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.348',
              'Technische Hochschule Mittelhessen - THM'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.349',
              'Technische Hochschule Nürnberg Georg Simon Ohm'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.350',
              'Technische Hochschule Ostwestfalen-Lippe '
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.351',
              'Technische Hochschule Rosenheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.352',
              'Technische Hochschule Ulm'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.353',
              'Technische Hochschule Wildau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.354',
              'Technische Hochschule Würzburg-Schweinfurt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.355',
              'Technische Universität Bergakademie Freiberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.356',
              'Technische Universität Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.357',
              'Technische Universität Carolo-Wilhelmina zu Braunschweig'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.358',
              'Technische Universität Chemnitz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.359',
              'Technische Universität Clausthal'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.360',
              'Technische Universität Darmstadt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.361',
              'Technische Universität Dortmund'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.362',
              'Technische Universität Dresden'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.363',
              'Technische Universität Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.364',
              'Technische Universität Ilmenau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.365',
              'Technische Universität München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.366',
              'Theologische Fakultät Fulda'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.367',
              'Theologische Fakultät Paderborn'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.368',
              'Theologische Fakultät Trier'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.369',
              'Theologische Hochschule Elstal'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.370',
              'Theologische Hochschule Friedensau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.371',
              'Theologische Hochschule Reutlingen - staatlich anerkannte Fachhochschule der Evangelisch-methodistischen Kirche'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.372',
              'Theologisches Hochschule Ewersbach'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.373',
              'Thüringer Fachhochschule für öffentliche Verwaltung'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.374',
              'Touro College Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.375',
              'University of Europe for Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.376',
              'University of Labour'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.377',
              'Universität Augsburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.378',
              'Universität Bayreuth'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.379',
              'Universität Bielefeld'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.380',
              'Universität Bremen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.381',
              'Universität Duisburg-Essen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.382',
              'Universität Erfurt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.383',
              'Universität Greifswald'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.384',
              'Universität Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.385',
              'Universität Hildesheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.386',
              'Universität Hohenheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.387',
              'Universität Kassel'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.388',
              'Universität Koblenz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.389',
              'Universität Konstanz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.390',
              'Universität Leipzig'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.391',
              'Universität Mannheim'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.392',
              'Universität Osnabrück'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.393',
              'Universität Paderborn'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.394',
              'Universität Passau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.395',
              'Universität Potsdam'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.396',
              'Universität Regensburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.397',
              'Universität Rostock'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.398',
              'Universität Siegen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.399',
              'Universität Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.400',
              'Universität Trier'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.401',
              'Universität Ulm'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.402',
              'Universität Vechta'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.403',
              'Universität der Bundeswehr München'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.404',
              'Universität der Künste Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.405',
              'Universität des Saarlandes'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.406',
              'Universität zu Köln'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.407',
              'Universität zu Lübeck'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.408',
              'VICTORIA | Internationale Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.409',
              'VWA-Hochschule für berufsbegleitendes Studium'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.410',
              'Vinzenz Pallotti University'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.411',
              'WHU - Otto Beisheim School of Management'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.412',
              'Westfälische Hochschule Gelsenkirchen, Bocholt, Recklinghausen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.413',
              'Westfälische Wilhelms-Universität Münster'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.414',
              'Westsächsische Hochschule Zwickau'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.415',
              'Wilhelm Büchner Hochschule - Private Fernhochschule Darmstadt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.416',
              'XU Exponential University of Applied Sciences'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.417',
              'Zeppelin Universität - Hochschule zwischen Wirtschaft, Kultur und Politik'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.418',
              'accadis Hochschule Bad Homburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.419',
              'bbw Hochschule'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.420',
              'hochschule 21'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.421',
              'media Akademie - Hochschule Stuttgart'
            ),
            t(
              'questionnaire.publicHealthDe.signup.university.props.options.422',
              'weißensee kunsthochschule berlin'
            ),
          ],
        },
        type: 'AUTOSUGGEST',
      },
      {
        id: 'universityNotListedBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 55,
          title: t(
            'questionnaire.publicHealthDe.signup.universityNotListedBlocker.props.title',
            'You might not be eligible for public health insurance'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.universityNotListedBlocker.props.description',
            'Only students at state-accredited universities are eligible for student public health insurance. If your university is not on the list, it is likely private and not state-accredited.\n\nIf you have confirmed with your university that you could be publicly insured, please proceed with your application here and we will verify your eligibility. Otherwise, you can sign up for expat health insurance.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 61,
              caption: t(
                'questionnaire.publicHealthDe.signup.universityNotListedBlocker.option.0.caption',
                'Learn about expat health'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/health-insurance/expat',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 62,
              caption: t(
                'questionnaire.publicHealthDe.signup.universityNotListedBlocker.option.1.caption',
                'Continue public sign-up'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'submit',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'universityName',
        __component: 'questionnaire.input-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 107,
          value: 'Personal',
        },
        screen: {
          id: 160,
          question: t(
            'questionnaire.publicHealthDe.signup.universityName.screen.question',
            'Which university will you be studying at?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.universityName.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 21,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.universityName.props.placeholder',
            'University name'
          ),
          label: null,
          maxLength: null,
          minLength: null,
        },
        type: 'INPUT',
      },
      {
        id: 'universityAddress',
        __component: 'questionnaire.address-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 109,
          value: 'Personal',
        },
        screen: {
          id: 162,
          question: t(
            'questionnaire.publicHealthDe.signup.universityAddress.screen.question',
            'Which university will you be studying at?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.universityAddress.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 5,
          countryCode: t(
            'questionnaire.publicHealthDe.signup.universityAddress.props.countryCode',
            'de'
          ),
          dynamicCountryCode: null,
        },
        type: 'ADDRESS',
      },
      {
        id: 'worksMoreThanTwentyHours',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 108,
          value: 'Personal',
        },
        screen: {
          id: 161,
          question: t(
            'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHours.screen.question',
            'Are you working more than 20 hours per week as an employee or a freelancer?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHours.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: {
            id: 18,
            title: t(
              'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHours.screen.additionalInfo.title',
              'Working student rules'
            ),
            description: t(
              'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHours.screen.additionalInfo.description',
              'If you have a working student (Werkstudent) or internship contract, you are allowed to work more than 20h per week during certain periods. If that\'s the case, your can select "No".'
            ),
            moreInfoLink:
              'https://faq.feather-insurance.com/en/articles/28594-i-want-to-work-while-studying-what-are-the-exact-rules',
          },
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'worksMoreThanTwentyHoursBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          id: 163,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHoursBlocker.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Standalone',
        },
        props: {
          id: 24,
          title: t(
            'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHoursBlocker.props.title',
            'Please change your main occupation'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHoursBlocker.props.description',
            'Since you’re working more than 20h per week, we cannot sign you up as a student. Please continue your **sign-up as an employee or a self-employed person instead**.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 23,
              caption: t(
                'questionnaire.publicHealthDe.signup.worksMoreThanTwentyHoursBlocker.option.0.caption',
                'Change my occupation'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'question-id',
              href: null,
              value: null,
              redirectToQuestionId: 'occupation',
              questionId: 'occupation',
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'universityStartDate',
        __component: 'questionnaire.date-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 110,
          value: 'Personal',
        },
        screen: {
          id: 164,
          question: t(
            'questionnaire.publicHealthDe.signup.universityStartDate.screen.question',
            'When does your first semester begin?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.universityStartDate.screen.description',
            'The date is most likely going to be the 1st of April or 1st of October.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.universityStartDate.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 19,
          yearRange: {
            id: 20,
            min: {
              id: 40,
              op: 'subtract',
              value: 3,
              type: 'years',
            },
            max: {
              id: 41,
              op: 'add',
              value: 1,
              type: 'years',
            },
          },
        },
        validations: [],
        type: 'DATE',
      },
      {
        id: 'familyReunionVisaBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          id: 159,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.familyReunionVisaBlocker.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Standalone',
        },
        props: {
          id: 19,
          title: t(
            'questionnaire.publicHealthDe.signup.familyReunionVisaBlocker.props.title',
            "We're sorry..."
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.familyReunionVisaBlocker.props.description',
            'Unfortunately, we cannot help you sign up for public health insurance at this time. You can find out more about the health insurance options for a family reunion visa.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 18,
              caption: t(
                'questionnaire.publicHealthDe.signup.familyReunionVisaBlocker.option.0.caption',
                'Read our FAQ'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://faq.feather-insurance.com/en/articles/30739-health-insurance-for-a-family-reunion-visa',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'phdDoctorateBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          id: 165,
          question: null,
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.phdDoctorateBlocker.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Standalone',
        },
        props: {
          id: 25,
          title: t(
            'questionnaire.publicHealthDe.signup.phdDoctorateBlocker.props.title',
            'You might have a few options available'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.phdDoctorateBlocker.props.description',
            'If you are starting a PhD in Germany, you may have various insurance options at your disposal depending on your exact situation. '
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 24,
              caption: t(
                'questionnaire.publicHealthDe.signup.phdDoctorateBlocker.option.0.caption',
                'Learn about my options'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://faq.feather-insurance.com/en/articles/136067-i-m-a-phd-student-which-insurance-options-do-i-have',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 64,
              caption: t(
                'questionnaire.publicHealthDe.signup.phdDoctorateBlocker.option.1.caption',
                'Select an occupation'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'question-id',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: 'occupation',
              questionId: 'occupation',
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'internBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 26,
          title: t(
            'questionnaire.publicHealthDe.signup.internBlocker.props.title',
            'You might have a few options available'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.internBlocker.props.description',
            'If you are going to do internship in Germany, you may have various insurance options at your disposal, depending on your exact situation. Please find more information in our FAQ.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 25,
              caption: t(
                'questionnaire.publicHealthDe.signup.internBlocker.option.0.caption',
                'Read our FAQ'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://faq.feather-insurance.com/en/articles/31323-how-are-interns-health-insured-in-germany',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 65,
              caption: t(
                'questionnaire.publicHealthDe.signup.internBlocker.option.1.caption',
                'Select an occupation'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'question-id',
              href: null,
              value: true,
              redirectToQuestionId: 'occupation',
              questionId: 'occupation',
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'hasGermanPublicHealthInsurance',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 112,
          value: 'Personal',
        },
        screen: {
          id: 167,
          question: t(
            'questionnaire.publicHealthDe.signup.hasGermanPublicHealthInsurance.screen.question',
            'Are you currently on public health insurance in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasGermanPublicHealthInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'hasPublicHealthInsurance',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 66,
          value: 'Personal',
        },
        screen: {
          id: 111,
          question: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInsurance.screen.question',
            'Do you currently have any public health insurance?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasPublicHealthInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: {
            id: 10,
            title: t(
              'questionnaire.publicHealthDe.signup.hasPublicHealthInsurance.screen.additionalInfo.title',
              'What is public insurance?'
            ),
            description: t(
              'questionnaire.publicHealthDe.signup.hasPublicHealthInsurance.screen.additionalInfo.description',
              'Public insurance refers to state insurance or universal health care.\n'
            ),
            moreInfoLink: null,
          },
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.country_single-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 321,
          value: 'Personal',
        },
        screen: {
          id: 388,
          question: t(
            'questionnaire.publicHealthDe.signup.previousCountryOfInsurance.screen.question',
            'In which country are you publicly insured?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.previousCountryOfInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 6,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.previousCountryOfInsurance.props.placeholder',
            'Country'
          ),
        },
        type: 'COUNTRY_SINGLE',
      },
      {
        id: 'hadOneDayPublicHealthInsurance',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 116,
          value: 'Personal',
        },
        screen: {
          id: 171,
          question: t(
            'questionnaire.publicHealthDe.signup.hadOneDayPublicHealthInsurance.screen.question',
            'Have you had public health insurance for at least 1 day in the last 5 years in EU, EEA, Switzerland or the UK?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hadOneDayPublicHealthInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'pastFiveYearsInGermany',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 117,
          value: 'Personal',
        },
        screen: {
          id: 172,
          question: t(
            'questionnaire.publicHealthDe.signup.pastFiveYearsInGermany.screen.question',
            'Have you lived in Germany at any point in the last 5 years?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.pastFiveYearsInGermany.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'insuranceTwelveMonths',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 222,
          value: 'Personal',
        },
        screen: {
          id: 265,
          question: t(
            'questionnaire.publicHealthDe.signup.insuranceTwelveMonths.screen.question',
            'Have you had that insurance for the last 12 months?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.insuranceTwelveMonths.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'insuranceTwentyFourMonths',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 223,
          value: 'Personal',
        },
        screen: {
          id: 266,
          question: t(
            'questionnaire.publicHealthDe.signup.insuranceTwentyFourMonths.screen.question',
            'Have you been publicly insured for at least 24 months in the last 5 years?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.insuranceTwentyFourMonths.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'studentHasPublicHealthInsurance',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 118,
          value: 'Personal',
        },
        screen: {
          id: 173,
          question: t(
            'questionnaire.publicHealthDe.signup.studentHasPublicHealthInsurance.screen.question',
            'Do you currently have any public health insurance?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.studentHasPublicHealthInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: {
            id: 20,
            title: t(
              'questionnaire.publicHealthDe.signup.studentHasPublicHealthInsurance.screen.additionalInfo.title',
              'What is public insurance?'
            ),
            description: t(
              'questionnaire.publicHealthDe.signup.studentHasPublicHealthInsurance.screen.additionalInfo.description',
              'Public insurance refers to state insurance or universal health care.\n\n'
            ),
            moreInfoLink: null,
          },
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'studentAboveAgeBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 27,
          title: t(
            'questionnaire.publicHealthDe.signup.studentAboveAgeBlocker.props.title',
            'We’re sorry...'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.studentAboveAgeBlocker.props.description',
            'Since you’ll be over 30 years old at the start of your studies you can’t sign up for Public Health Insurance as a student.\n\nBut no worries, you have various insurance options at your disposal depending on your exact situation.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 26,
              caption: t(
                'questionnaire.publicHealthDe.signup.studentAboveAgeBlocker.option.0.caption',
                'Learn about your options'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://faq.feather-insurance.com/en/articles/28593-health-insurance-for-students-over-30',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'studentPreviousCountryOfInsurance',
        __component: 'questionnaire.country_single-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 322,
          value: 'Personal',
        },
        screen: {
          id: 389,
          question: t(
            'questionnaire.publicHealthDe.signup.studentPreviousCountryOfInsurance.screen.question',
            'In which country are you publicly insured?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.studentPreviousCountryOfInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 7,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.studentPreviousCountryOfInsurance.props.placeholder',
            'Country'
          ),
        },
        type: 'COUNTRY_SINGLE',
      },
      {
        id: 'ehicCard',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 213,
          value: 'Personal',
        },
        screen: {
          id: 255,
          question: t(
            'questionnaire.publicHealthDe.signup.ehicCard.screen.question',
            'Do you want to use the insurance from your home country in Germany?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.ehicCard.screen.description',
            'If your home state/public insurance agreed to cover your stay in Germany during studies, you can keep your home insurance, and have access to healthcare in Germany by presenting the relevant document, such as EHIC (European Health Insurance Card).'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.ehicCard.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: {
            id: 52,
            title: t(
              'questionnaire.publicHealthDe.signup.ehicCard.screen.additionalInfo.title',
              'Should I stay on my home public insurance?'
            ),
            description: t(
              'questionnaire.publicHealthDe.signup.ehicCard.screen.additionalInfo.description',
              'There are certain scenarios in which you most likely have to get a german insurance. For example, if you start working during your studies or move your permanent residence to Germany. \n\n[Help me choose](https://faq.feather-insurance.com//en/articles/28737-i-m-a-university-student-from-the-eu-how-do-i-get-covered)\n\n\n'
            ),
            moreInfoLink: null,
          },
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'weCanHelpStudentBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 43,
          title: t(
            'questionnaire.publicHealthDe.signup.weCanHelpStudentBlocker.props.title',
            'We can help with the insurance confirmation'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.weCanHelpStudentBlocker.props.description',
            'Since you will not sign up for health insurance in Germany, your university will require the confirmation of your valid home insurance (M10 report), and it can only come from a German public health insurance provider. We can help you with that.\n\nHave in mind to always confirm with your home insurance provider the conditions under which they will cover your stay in Germany during studies.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 43,
              caption: t(
                'questionnaire.publicHealthDe.signup.weCanHelpStudentBlocker.option.0.caption',
                'Learn more'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://faq.feather-insurance.com//en/articles/28737-i-m-a-university-student-from-the-eu-how-do-i-get-covered',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'expatOrPrivateHealthInsurance',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 214,
          value: 'Personal',
        },
        screen: {
          id: 256,
          question: t(
            'questionnaire.publicHealthDe.signup.expatOrPrivateHealthInsurance.screen.question',
            'Do you have an expat (incoming) or private health insurance in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.expatOrPrivateHealthInsurance.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'studentOnExpatOrPrivateBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 44,
          title: t(
            'questionnaire.publicHealthDe.signup.studentOnExpatOrPrivateBlocker.props.title',
            'You are not eligible for student public health insurance'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.studentOnExpatOrPrivateBlocker.props.description',
            'If you are currently on private or incoming (expat) insurance and want to switch in the middle of studies, you are unfortunately not eligible for public health insurance as a student because you got exempted at the beginning of studies. A mini-job or working student contract don’t make you eligible, and you have to stay on your insurance until you get a regular employment contract with more than 20 hours per week.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 44,
              caption: t(
                'questionnaire.publicHealthDe.signup.studentOnExpatOrPrivateBlocker.option.0.caption',
                'Learn about Expat Health'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/health-insurance/expat',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'currentlyOnPrivate',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 218,
          value: 'Personal',
        },
        screen: {
          id: 261,
          question: t(
            'questionnaire.publicHealthDe.signup.currentlyOnPrivate.screen.question',
            'Are you currently on private health insurance in Germany?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.currentlyOnPrivate.screen.description',
            'Select no if it’s an incoming/expat insurance.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.currentlyOnPrivate.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'lastInsuranceInGermany',
        __component: 'questionnaire.radio-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 219,
          value: 'Personal',
        },
        screen: {
          id: 262,
          question: t(
            'questionnaire.publicHealthDe.signup.lastInsuranceInGermany.screen.question',
            'What was your last insurance in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.lastInsuranceInGermany.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 28,
          mapValue: {
            PUBLIC: t(
              'questionnaire.publicHealthDe.signup.lastInsuranceInGermany.option.publicOption',
              'Public (statutory)'
            ),
            PRIVATE: t(
              'questionnaire.publicHealthDe.signup.lastInsuranceInGermany.option.privateOption',
              'Private'
            ),
          },
        },
        type: 'RADIO',
      },
      {
        id: 'employmentWithinTwoMonthsOfArrival',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 220,
          value: 'Personal',
        },
        screen: {
          id: 263,
          question: t(
            'questionnaire.publicHealthDe.signup.employmentWithinTwoMonthsOfArrival.screen.question',
            'Does your employment start within 2 months of your arrival in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.employmentWithinTwoMonthsOfArrival.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'inEligibleTwoMonthsAfterArrivalBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 46,
          title: t(
            'questionnaire.publicHealthDe.signup.inEligibleTwoMonthsAfterArrivalBlocker.props.title',
            'You’re currently not eligible'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.inEligibleTwoMonthsAfterArrivalBlocker.props.description',
            'If you’re returning to Germany to work again, you have to start your employment within 2 months of arrival in order to be eligible for public health insurance.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 47,
              caption: t(
                'questionnaire.publicHealthDe.signup.inEligibleTwoMonthsAfterArrivalBlocker.option.0.caption',
                'Learn about private insurance'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/health-insurance/private',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 48,
              caption: t(
                'questionnaire.publicHealthDe.signup.inEligibleTwoMonthsAfterArrivalBlocker.option.1.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'ineligibleOverPrivateThreshold',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 30,
          title: t(
            'questionnaire.publicHealthDe.signup.ineligibleOverPrivateThreshold.props.title',
            'You’re currently not eligible'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.ineligibleOverPrivateThreshold.props.description',
            'Eligibility for public health insurance depends on your occupation, income, and other factors like your insurance history. You’re not [meeting the requirements](https://faq.feather-insurance.com/en/articles/28753-am-i-eligible-for-public-health-insurance-in-germany) for being insured on public health insurance, but might be eligible for private insurance instead.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 31,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleOverPrivateThreshold.option.0.caption',
                'Learn about private health'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/health-insurance/private',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 32,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleOverPrivateThreshold.option.1.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/support',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'ineligibleUnderPrivateThreshold',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 31,
          title: t(
            'questionnaire.publicHealthDe.signup.ineligibleUnderPrivateThreshold.props.title',
            'You’re currently not eligible'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.ineligibleUnderPrivateThreshold.props.description',
            'Eligibility for public health insurance depends on your occupation, income, and other factors like your insurance history. You’re not [meeting the requirements](https://faq.feather-insurance.com/en/articles/28753-am-i-eligible-for-public-health-insurance-in-germany) for being insured on public health insurance.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 33,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleUnderPrivateThreshold.option.0.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/support',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'ineligibleExpatHealth',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 29,
          title: t(
            'questionnaire.publicHealthDe.signup.ineligibleExpatHealth.props.title',
            'You’re currently not eligible'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.ineligibleExpatHealth.props.description',
            'Eligibility for public health insurance depends on your occupation, income, and other factors like your insurance history. You’re not [meeting the requirements](https://faq.feather-insurance.com/en/articles/28753-am-i-eligible-for-public-health-insurance-in-germany) for being insured on public health insurance, but might be eligible for expat health insurance instead.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 29,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleExpatHealth.option.0.caption',
                'Learn about Expat Health'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/health-insurance/expat/short-term',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 30,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleExpatHealth.option.1.caption',
                'Contact Us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/support',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'ineligibleLearnOptions',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 28,
          title: t(
            'questionnaire.publicHealthDe.signup.ineligibleLearnOptions.props.title',
            'You’re currently not eligible'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.ineligibleLearnOptions.props.description',
            'Eligibility for public health insurance depends on your occupation, income, and other factors like your insurance history. You’re not [meeting the requirements](https://faq.feather-insurance.com/en/articles/28753-am-i-eligible-for-public-health-insurance-in-germany) for being insured on public health insurance.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 28,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleLearnOptions.option.0.caption',
                'Learn about your options'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://app.staging.feather-insurance.com/recommendation-tool',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 27,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligibleLearnOptions.option.1.caption',
                'Contact Us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://staging.feather-insurance.com/support',
              value: null,
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'ineligiblePrivateBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 45,
          title: t(
            'questionnaire.publicHealthDe.signup.ineligiblePrivateBlocker.props.title',
            'You’re currently not eligible'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.ineligiblePrivateBlocker.props.description',
            'Since you were previously on private health insurance in Germany, it’s not possible for you to switch to the public system.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 45,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligiblePrivateBlocker.option.0.caption',
                'Learn about private insurance'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/health-insurance/private',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 46,
              caption: t(
                'questionnaire.publicHealthDe.signup.ineligiblePrivateBlocker.option.1.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'lastProviderInGermany',
        __component: 'questionnaire.autosuggest-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 221,
          value: 'Personal',
        },
        screen: {
          id: 264,
          question: t(
            'questionnaire.publicHealthDe.signup.lastProviderInGermany.screen.question',
            'Which public health provider were you last with in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.lastProviderInGermany.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: {
            id: 17,
            title: t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.screen.skipDetails.title',
              'My provider is not listed'
            ),
            path: null,
            skipQuestion: {
              value: '',
            },
          },
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 9,
          externalList: null,
          cmsList: {
            data: {
              id: 3,
              attributes: {
                name: 'publicHealthPreviousinsurer',
                createdAt: '2024-12-31T18:17:15.933Z',
                updatedAt: '2025-02-27T15:52:08.175Z',
                publishedAt: '2024-12-31T18:20:13.569Z',
                values: [
                  {
                    id: 3,
                    __component: 'questionnaire.autocomplete-list',
                    autosuggestValues: [
                      'AOK Baden-Württemberg',
                      'AOK Bayern',
                      'AOK Bremen/Bremerhaven',
                      'AOK Hessen',
                      'AOK Niedersachsen',
                      'AOK Nordost',
                      'AOK Nordwest',
                      'AOK PLUS',
                      'AOK Rheinland-Pfalz/Saarland',
                      'AOK Rheinland/Hamburg',
                      'AOK Sachsen-Anhalt',
                      'Audi BKK',
                      'BAHN-BKK',
                      'BARMER',
                      'BERGISCHE Krankenkasse',
                      'Bertelsmann BKK',
                      'BIG Direkt Gesund',
                      'BKK Aesculap',
                      'BKK Akzo Nobel Bayern',
                      'BKK B. Braun Aesculap',
                      'BKK Deutsche Bank AG',
                      'BKK Diakonie',
                      'BKK DürkoppAdler',
                      'BKK EUREGIO',
                      'BKK evm',
                      'BKK EWE',
                      'BKK exklusiv',
                      'BKK Faber-Castell & Partner',
                      'BKK firmus',
                      'BKK Freudenberg',
                      'BKK Gildemeister Seidensticker',
                      'BKK Groz-Beckert',
                      'BKK HERKULES',
                      'BKK KARL MAYER',
                      'BKK Linde',
                      'BKK MAHLE',
                      'BKK Melitta HMR',
                      'BKK Merck',
                      'BKK Miele',
                      'BKK MTU',
                      'BKK PFAFF',
                      'BKK Pfalz',
                      'BKK ProVita',
                      'BKK Public',
                      'BKK PwC',
                      'BKK Rieker.Ricosta.Weisser',
                      'BKK Salzgitter',
                      'BKK SBH',
                      'BKK Scheufelen',
                      'BKK Technoform',
                      'BKK Textilgruppe Hof',
                      'BKK VBU',
                      'BKK VDN',
                      'BKK VerbundPlus',
                      'BKK Voralb HELLER*INDEX*LEUZE',
                      'BKK Werra-Meissner',
                      'BKK WIRTSCHAFT & FINANZEN',
                      'BKK Würth',
                      'BKK ZF & Partner',
                      'BKK24',
                      'BMW BKK',
                      'Bosch BKK',
                      'Continentale BKK',
                      'Mercedes-Benz BKK',
                      'DAK Gesundheit',
                      'Debeka BKK',
                      'Energie-BKK',
                      'Ernst & Young BKK',
                      'Heimat Krankenkasse',
                      'HEK - Hanseatische Krankenkasse',
                      'HKK Krankenkasse',
                      'IKK - Die Innovationskasse',
                      'IKK Brandenburg und Berlin',
                      'IKK Classic',
                      'IKK Gesund Plus',
                      'IKK Südwest',
                      'KKH Kaufmännische Krankenkasse',
                      'KNAPPSCHAFT',
                      'Koenig & Bauer BKK',
                      'Krones BKK',
                      'Sozialversicherung für Landwirtschaft, Forsten und Gartenbau - SVLFG',
                      'Mhplus BKK',
                      'BKK Mobil',
                      'Novitas BKK',
                      'Pronova BKK',
                      'R+V Betriebskrankenkasse',
                      'Salus BKK',
                      'SBK',
                      'SECURVITA Krankenkasse',
                      'SKD BKK',
                      'Südzucker-BKK',
                      'Techniker Krankenkasse (TK)',
                      'TUI BKK',
                      'VIACTIV Krankenkasse',
                      'Vivida BKK',
                      'WMF BKK',
                    ],
                  },
                ],
              },
            },
          },
          options: [
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.0',
              'AOK Baden-Württemberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.1',
              'AOK Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.2',
              'AOK Bremen/Bremerhaven'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.3',
              'AOK Hessen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.4',
              'AOK Niedersachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.5',
              'AOK Nordost'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.6',
              'AOK Nordwest'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.7',
              'AOK PLUS'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.8',
              'AOK Rheinland-Pfalz/Saarland'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.9',
              'AOK Rheinland/Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.10',
              'AOK Sachsen-Anhalt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.11',
              'Audi BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.12',
              'BAHN-BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.13',
              'BARMER'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.14',
              'BERGISCHE Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.15',
              'Bertelsmann BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.16',
              'BIG Direkt Gesund'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.17',
              'BKK Aesculap'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.18',
              'BKK Akzo Nobel Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.19',
              'BKK B. Braun Aesculap'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.20',
              'BKK Deutsche Bank AG'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.21',
              'BKK Diakonie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.22',
              'BKK DürkoppAdler'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.23',
              'BKK EUREGIO'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.24',
              'BKK evm'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.25',
              'BKK EWE'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.26',
              'BKK exklusiv'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.27',
              'BKK Faber-Castell & Partner'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.28',
              'BKK firmus'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.29',
              'BKK Freudenberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.30',
              'BKK Gildemeister Seidensticker'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.31',
              'BKK Groz-Beckert'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.32',
              'BKK HERKULES'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.33',
              'BKK KARL MAYER'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.34',
              'BKK Linde'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.35',
              'BKK MAHLE'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.36',
              'BKK Melitta HMR'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.37',
              'BKK Merck'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.38',
              'BKK Miele'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.39',
              'BKK MTU'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.40',
              'BKK PFAFF'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.41',
              'BKK Pfalz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.42',
              'BKK ProVita'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.43',
              'BKK Public'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.44',
              'BKK PwC'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.45',
              'BKK Rieker.Ricosta.Weisser'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.46',
              'BKK Salzgitter'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.47',
              'BKK SBH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.48',
              'BKK Scheufelen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.49',
              'BKK Technoform'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.50',
              'BKK Textilgruppe Hof'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.51',
              'BKK VBU'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.52',
              'BKK VDN'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.53',
              'BKK VerbundPlus'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.54',
              'BKK Voralb HELLER*INDEX*LEUZE'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.55',
              'BKK Werra-Meissner'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.56',
              'BKK WIRTSCHAFT & FINANZEN'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.57',
              'BKK Würth'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.58',
              'BKK ZF & Partner'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.59',
              'BKK24'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.60',
              'BMW BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.61',
              'Bosch BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.62',
              'Continentale BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.63',
              'Mercedes-Benz BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.64',
              'DAK Gesundheit'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.65',
              'Debeka BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.66',
              'Energie-BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.67',
              'Ernst & Young BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.68',
              'Heimat Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.69',
              'HEK - Hanseatische Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.70',
              'HKK Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.71',
              'IKK - Die Innovationskasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.72',
              'IKK Brandenburg und Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.73',
              'IKK Classic'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.74',
              'IKK Gesund Plus'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.75',
              'IKK Südwest'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.76',
              'KKH Kaufmännische Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.77',
              'KNAPPSCHAFT'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.78',
              'Koenig & Bauer BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.79',
              'Krones BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.80',
              'Sozialversicherung für Landwirtschaft, Forsten und Gartenbau - SVLFG'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.81',
              'Mhplus BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.82',
              'BKK Mobil'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.83',
              'Novitas BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.84',
              'Pronova BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.85',
              'R+V Betriebskrankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.86',
              'Salus BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.87',
              'SBK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.88',
              'SECURVITA Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.89',
              'SKD BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.90',
              'Südzucker-BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.91',
              'Techniker Krankenkasse (TK)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.92',
              'TUI BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.93',
              'VIACTIV Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.94',
              'Vivida BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.lastProviderInGermany.props.options.95',
              'WMF BKK'
            ),
          ],
        },
        type: 'AUTOSUGGEST',
      },
      {
        id: 'previousInsurer',
        __component: 'questionnaire.autosuggest-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 113,
          value: 'Personal',
        },
        screen: {
          id: 168,
          question: t(
            'questionnaire.publicHealthDe.signup.previousInsurer.screen.question',
            'What’s your health insurance provider’s name?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.previousInsurer.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: {
            id: 12,
            title: t(
              'questionnaire.publicHealthDe.signup.previousInsurer.screen.skipDetails.title',
              'My provider is not listed'
            ),
            path: null,
            skipQuestion: {
              value: '',
            },
          },
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 8,
          externalList: null,
          cmsList: {
            data: {
              id: 3,
              attributes: {
                name: 'publicHealthPreviousinsurer',
                createdAt: '2024-12-31T18:17:15.933Z',
                updatedAt: '2025-02-27T15:52:08.175Z',
                publishedAt: '2024-12-31T18:20:13.569Z',
                values: [
                  {
                    id: 3,
                    __component: 'questionnaire.autocomplete-list',
                    autosuggestValues: [
                      'AOK Baden-Württemberg',
                      'AOK Bayern',
                      'AOK Bremen/Bremerhaven',
                      'AOK Hessen',
                      'AOK Niedersachsen',
                      'AOK Nordost',
                      'AOK Nordwest',
                      'AOK PLUS',
                      'AOK Rheinland-Pfalz/Saarland',
                      'AOK Rheinland/Hamburg',
                      'AOK Sachsen-Anhalt',
                      'Audi BKK',
                      'BAHN-BKK',
                      'BARMER',
                      'BERGISCHE Krankenkasse',
                      'Bertelsmann BKK',
                      'BIG Direkt Gesund',
                      'BKK Aesculap',
                      'BKK Akzo Nobel Bayern',
                      'BKK B. Braun Aesculap',
                      'BKK Deutsche Bank AG',
                      'BKK Diakonie',
                      'BKK DürkoppAdler',
                      'BKK EUREGIO',
                      'BKK evm',
                      'BKK EWE',
                      'BKK exklusiv',
                      'BKK Faber-Castell & Partner',
                      'BKK firmus',
                      'BKK Freudenberg',
                      'BKK Gildemeister Seidensticker',
                      'BKK Groz-Beckert',
                      'BKK HERKULES',
                      'BKK KARL MAYER',
                      'BKK Linde',
                      'BKK MAHLE',
                      'BKK Melitta HMR',
                      'BKK Merck',
                      'BKK Miele',
                      'BKK MTU',
                      'BKK PFAFF',
                      'BKK Pfalz',
                      'BKK ProVita',
                      'BKK Public',
                      'BKK PwC',
                      'BKK Rieker.Ricosta.Weisser',
                      'BKK Salzgitter',
                      'BKK SBH',
                      'BKK Scheufelen',
                      'BKK Technoform',
                      'BKK Textilgruppe Hof',
                      'BKK VBU',
                      'BKK VDN',
                      'BKK VerbundPlus',
                      'BKK Voralb HELLER*INDEX*LEUZE',
                      'BKK Werra-Meissner',
                      'BKK WIRTSCHAFT & FINANZEN',
                      'BKK Würth',
                      'BKK ZF & Partner',
                      'BKK24',
                      'BMW BKK',
                      'Bosch BKK',
                      'Continentale BKK',
                      'Mercedes-Benz BKK',
                      'DAK Gesundheit',
                      'Debeka BKK',
                      'Energie-BKK',
                      'Ernst & Young BKK',
                      'Heimat Krankenkasse',
                      'HEK - Hanseatische Krankenkasse',
                      'HKK Krankenkasse',
                      'IKK - Die Innovationskasse',
                      'IKK Brandenburg und Berlin',
                      'IKK Classic',
                      'IKK Gesund Plus',
                      'IKK Südwest',
                      'KKH Kaufmännische Krankenkasse',
                      'KNAPPSCHAFT',
                      'Koenig & Bauer BKK',
                      'Krones BKK',
                      'Sozialversicherung für Landwirtschaft, Forsten und Gartenbau - SVLFG',
                      'Mhplus BKK',
                      'BKK Mobil',
                      'Novitas BKK',
                      'Pronova BKK',
                      'R+V Betriebskrankenkasse',
                      'Salus BKK',
                      'SBK',
                      'SECURVITA Krankenkasse',
                      'SKD BKK',
                      'Südzucker-BKK',
                      'Techniker Krankenkasse (TK)',
                      'TUI BKK',
                      'VIACTIV Krankenkasse',
                      'Vivida BKK',
                      'WMF BKK',
                    ],
                  },
                ],
              },
            },
          },
          options: [
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.0',
              'AOK Baden-Württemberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.1',
              'AOK Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.2',
              'AOK Bremen/Bremerhaven'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.3',
              'AOK Hessen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.4',
              'AOK Niedersachsen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.5',
              'AOK Nordost'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.6',
              'AOK Nordwest'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.7',
              'AOK PLUS'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.8',
              'AOK Rheinland-Pfalz/Saarland'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.9',
              'AOK Rheinland/Hamburg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.10',
              'AOK Sachsen-Anhalt'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.11',
              'Audi BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.12',
              'BAHN-BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.13',
              'BARMER'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.14',
              'BERGISCHE Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.15',
              'Bertelsmann BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.16',
              'BIG Direkt Gesund'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.17',
              'BKK Aesculap'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.18',
              'BKK Akzo Nobel Bayern'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.19',
              'BKK B. Braun Aesculap'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.20',
              'BKK Deutsche Bank AG'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.21',
              'BKK Diakonie'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.22',
              'BKK DürkoppAdler'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.23',
              'BKK EUREGIO'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.24',
              'BKK evm'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.25',
              'BKK EWE'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.26',
              'BKK exklusiv'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.27',
              'BKK Faber-Castell & Partner'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.28',
              'BKK firmus'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.29',
              'BKK Freudenberg'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.30',
              'BKK Gildemeister Seidensticker'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.31',
              'BKK Groz-Beckert'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.32',
              'BKK HERKULES'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.33',
              'BKK KARL MAYER'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.34',
              'BKK Linde'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.35',
              'BKK MAHLE'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.36',
              'BKK Melitta HMR'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.37',
              'BKK Merck'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.38',
              'BKK Miele'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.39',
              'BKK MTU'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.40',
              'BKK PFAFF'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.41',
              'BKK Pfalz'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.42',
              'BKK ProVita'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.43',
              'BKK Public'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.44',
              'BKK PwC'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.45',
              'BKK Rieker.Ricosta.Weisser'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.46',
              'BKK Salzgitter'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.47',
              'BKK SBH'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.48',
              'BKK Scheufelen'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.49',
              'BKK Technoform'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.50',
              'BKK Textilgruppe Hof'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.51',
              'BKK VBU'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.52',
              'BKK VDN'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.53',
              'BKK VerbundPlus'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.54',
              'BKK Voralb HELLER*INDEX*LEUZE'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.55',
              'BKK Werra-Meissner'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.56',
              'BKK WIRTSCHAFT & FINANZEN'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.57',
              'BKK Würth'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.58',
              'BKK ZF & Partner'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.59',
              'BKK24'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.60',
              'BMW BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.61',
              'Bosch BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.62',
              'Continentale BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.63',
              'Mercedes-Benz BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.64',
              'DAK Gesundheit'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.65',
              'Debeka BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.66',
              'Energie-BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.67',
              'Ernst & Young BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.68',
              'Heimat Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.69',
              'HEK - Hanseatische Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.70',
              'HKK Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.71',
              'IKK - Die Innovationskasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.72',
              'IKK Brandenburg und Berlin'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.73',
              'IKK Classic'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.74',
              'IKK Gesund Plus'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.75',
              'IKK Südwest'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.76',
              'KKH Kaufmännische Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.77',
              'KNAPPSCHAFT'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.78',
              'Koenig & Bauer BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.79',
              'Krones BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.80',
              'Sozialversicherung für Landwirtschaft, Forsten und Gartenbau - SVLFG'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.81',
              'Mhplus BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.82',
              'BKK Mobil'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.83',
              'Novitas BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.84',
              'Pronova BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.85',
              'R+V Betriebskrankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.86',
              'Salus BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.87',
              'SBK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.88',
              'SECURVITA Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.89',
              'SKD BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.90',
              'Südzucker-BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.91',
              'Techniker Krankenkasse (TK)'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.92',
              'TUI BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.93',
              'VIACTIV Krankenkasse'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.94',
              'Vivida BKK'
            ),
            t(
              'questionnaire.publicHealthDe.signup.previousInsurer.props.options.95',
              'WMF BKK'
            ),
          ],
        },
        type: 'AUTOSUGGEST',
      },
      {
        id: 'unlistedPreviousInsurer',
        __component: 'questionnaire.input-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 114,
          value: 'Personal',
        },
        screen: {
          id: 169,
          question: t(
            'questionnaire.publicHealthDe.signup.unlistedPreviousInsurer.screen.question',
            'Enter the name of the provider'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.unlistedPreviousInsurer.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 23,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.unlistedPreviousInsurer.props.placeholder',
            "Provider's name"
          ),
          label: null,
          maxLength: null,
          minLength: null,
        },
        type: 'INPUT',
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.processing',
        required: true,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 2,
          description: t(
            'questionnaire.publicHealthDe.signup.insuranceHistoryProcessing.props.description',
            'We’re reviewing your data to assess your eligibility'
          ),
          timeoutTime: null,
          textList: [
            t(
              'questionnaire.publicHealthDe.signup.insuranceHistoryProcessing.props.textList.0',
              'Checking your answers'
            ),
            t(
              'questionnaire.publicHealthDe.signup.insuranceHistoryProcessing.props.textList.1',
              'Analysing your insurance history'
            ),
          ],
        },
        type: 'PROCESSING',
      },
      {
        id: 'miniJobInsuredEuBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 52,
          title: t(
            'questionnaire.publicHealthDe.signup.miniJobInsuredEuBlocker.props.title',
            'Expat insurance could be a better option for you'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.miniJobInsuredEuBlocker.props.description',
            'Since you are earning under the threshold of €{{constants.miniJobThreshold}} per year, you cannot be insured through your employer and will need to pay the full contribution yourself — around €220 per month. This is definitely a good option if you have ongoing health issues and need constant treatment, since public insurance offers a broad scope of coverage. \n\nHowever, if that’s not the case and you want to sign up for a more affordable insurance, expat insurance might be a better choice. It starts at €72 per month, and you can still easily switch to public insurance through your employer if you start earning over €{{constants.miniJobThreshold}} per year.\n\nOne thing to keep in mind: if you plan on becoming self-employed directly after the minijob, you will only be eligible for public if your home insurance is still valid. In that case, choosing public insurance now might be your best option, even if the contribution is higher.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 55,
              caption: t(
                'questionnaire.publicHealthDe.signup.miniJobInsuredEuBlocker.option.0.caption',
                'Learn about expat health'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/health-insurance/expat',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 56,
              caption: t(
                'questionnaire.publicHealthDe.signup.miniJobInsuredEuBlocker.option.1.caption',
                'Continue public sign-up'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'submit',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'switchEmployedProvidersBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 53,
          title: t(
            'questionnaire.publicHealthDe.signup.switchEmployedProvidersBlocker.props.title',
            'Do you want to switch providers?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.switchEmployedProvidersBlocker.props.description',
            'You typically need to stay with your current provider for **at least 1 year** and have a [cancellation period](https://faq.feather-insurance.com/en/articles/28702-how-do-i-switch-or-cancel-public-health-insurance) of **2 full calendar months**. Your new policy will start after that.\n\nIf you **change your employer** or employment status, you can switch providers within the first 14 days. \n\nIf your **provider increased their prices**, the cancellation period is 2 full calendar months and you don’t need to wait 1 year — as long as you cancel within 1 month of the price increase.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 57,
              caption: t(
                'questionnaire.publicHealthDe.signup.switchEmployedProvidersBlocker.option.0.caption',
                'Yes, continue'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'submit',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 58,
              caption: t(
                'questionnaire.publicHealthDe.signup.switchEmployedProvidersBlocker.option.1.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'switchProvidersBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 54,
          title: t(
            'questionnaire.publicHealthDe.signup.switchProvidersBlocker.props.title',
            'Do you want to switch providers?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.switchProvidersBlocker.props.description',
            'You typically need to stay with your current provider for **at least 1 year** and have a [cancellation period](https://faq.feather-insurance.com/en/articles/28702-how-do-i-switch-or-cancel-public-health-insurance) of **2 full calendar months**. Your new policy will start after that.\n\nIf you **change your occupation**, other cancellation periods may apply. \n\nIf your **provider increased their prices**, the cancellation period is 2 full calendar months and you don’t need to wait 1 year — as long as you cancel within 1 month of the price increase.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 59,
              caption: t(
                'questionnaire.publicHealthDe.signup.switchProvidersBlocker.option.0.caption',
                'Yes, continue'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'submit',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 60,
              caption: t(
                'questionnaire.publicHealthDe.signup.switchProvidersBlocker.option.1.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'employerHasAlreadySignedUpBlocker',
        __component: 'questionnaire.blocker',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 47,
          title: t(
            'questionnaire.publicHealthDe.signup.employerHasAlreadySignedUpBlocker.props.title',
            'Your employer should have signed you up already'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.employerHasAlreadySignedUpBlocker.props.description',
            'Your employer has 6 weeks after your employment start date to sign you up for health insurance. You are likely already insured and should contact your employer for more details about your health insurance.\n\nIf you’re not insured yet or **if your income has changed** and you now have to be publicly insured, you can continue below.\n\nIf you aren’t sure or have questions, please get in touch with us.'
          ),
          additionalInfo: null,
          iconType: 'SHIELD',
          buttonProps: [
            {
              id: 49,
              caption: t(
                'questionnaire.publicHealthDe.signup.employerHasAlreadySignedUpBlocker.option.0.caption',
                'Contact us'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'href',
              href: 'https://feather-insurance.com/support',
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
            {
              id: 77,
              caption: t(
                'questionnaire.publicHealthDe.signup.employerHasAlreadySignedUpBlocker.option.1.caption',
                'Continue public sign-up'
              ),
              variant: 'SECONDARY',
              size: 'REGULAR',
              type: 'submit',
              href: null,
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              questionId: null,
            },
          ],
        },
        type: 'BLOCKER',
      },
      {
        id: 'switchingFromPrivate',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 580,
          value: 'Personal',
        },
        screen: {
          id: 719,
          question: t(
            'questionnaire.publicHealthDe.signup.switchingFromPrivate.screen.question',
            'Are you switching from comprehensive private insurance to public health insurance?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.switchingFromPrivate.screen.description',
            'This is the case if you were privately insured but your income falls under the threshold and you now need to be publicly insured.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.switchingFromPrivate.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'dateFallingBelowThreshold',
        __component: 'questionnaire.date-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 581,
          value: 'Personal',
        },
        screen: {
          id: 718,
          question: t(
            'questionnaire.publicHealthDe.signup.dateFallingBelowThreshold.screen.question',
            'When does your income change and fall under the threshold?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.dateFallingBelowThreshold.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 77,
          yearRange: {
            id: 79,
            min: {
              id: 159,
              op: 'subtract',
              value: 1,
              type: 'years',
            },
            max: {
              id: 160,
              op: 'add',
              value: 1,
              type: 'years',
            },
          },
        },
        validations: [],
        type: 'DATE',
      },
      {
        id: 'employerName',
        __component: 'questionnaire.input-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 231,
          value: 'Personal',
        },
        screen: {
          id: 280,
          question: t(
            'questionnaire.publicHealthDe.signup.employerName.screen.question',
            'Who is your employer?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.employerName.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 25,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.employerName.props.placeholder',
            'Employer'
          ),
          label: null,
          maxLength: null,
          minLength: null,
        },
        type: 'INPUT',
      },
      {
        id: 'jobTitle',
        __component: 'questionnaire.input-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 239,
          value: 'Personal',
        },
        screen: {
          id: 291,
          question: t(
            'questionnaire.publicHealthDe.signup.jobTitle.screen.question',
            'What’s your job title?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.jobTitle.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 27,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.jobTitle.props.placeholder',
            'Title'
          ),
          label: null,
          maxLength: null,
          minLength: null,
        },
        type: 'INPUT',
      },
      {
        id: 'companyAddress',
        __component: 'questionnaire.address-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 240,
          value: 'Personal',
        },
        screen: {
          id: 292,
          question: t(
            'questionnaire.publicHealthDe.signup.companyAddress.screen.question',
            'What’s your employer’s address in Germany?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.companyAddress.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 23,
          countryCode: t(
            'questionnaire.publicHealthDe.signup.companyAddress.props.countryCode',
            'de'
          ),
          dynamicCountryCode: null,
        },
        type: 'ADDRESS',
      },
      {
        id: 'hasTaxNumber',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 244,
          value: 'Personal',
        },
        screen: {
          id: 296,
          question: t(
            'questionnaire.publicHealthDe.signup.hasTaxNumber.screen.question',
            'Do you have a German tax number?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasTaxNumber.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'monthlyIncomeForNextYear',
        __component: 'questionnaire.currency-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 245,
          value: 'Personal',
        },
        screen: {
          id: 297,
          question: t(
            'questionnaire.publicHealthDe.signup.monthlyIncomeForNextYear.screen.question',
            'What is your monthly income for the next 12 months?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.monthlyIncomeForNextYear.screen.description',
            'This is gross income (i.e. before taxes)'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.monthlyIncomeForNextYear.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 2,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.monthlyIncomeForNextYear.props.placeholder',
            'Monthly income'
          ),
        },
        type: 'CURRENCY',
      },
      {
        id: 'agenturFurArbeitBenefits',
        __component: 'questionnaire.radio-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 246,
          value: 'Personal',
        },
        screen: {
          id: 298,
          question: t(
            'questionnaire.publicHealthDe.signup.agenturFurArbeitBenefits.screen.question',
            'Are you currently receiving any of these from the “Agentur für Arbeit”?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.agenturFurArbeitBenefits.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 31,
          mapValue: {
            GRUNDUNGSZUSCHUSS: t(
              'questionnaire.publicHealthDe.signup.agenturFurArbeitBenefits.option.grundungszuschussOption',
              'Gründungszuschuss'
            ),
            EINSTIEGSGELD: t(
              'questionnaire.publicHealthDe.signup.agenturFurArbeitBenefits.option.einstiegsgeldOption',
              'Einstiegsgeld'
            ),
            NONE: t(
              'questionnaire.publicHealthDe.signup.agenturFurArbeitBenefits.option.noneOption',
              'None of the above'
            ),
          },
        },
        type: 'RADIO',
      },
      {
        id: 'hasOtherIncome',
        __component: 'questionnaire.boolean-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 247,
          value: 'Personal',
        },
        screen: {
          id: 299,
          question: t(
            'questionnaire.publicHealthDe.signup.hasOtherIncome.screen.question',
            'Do you have any other form of income?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasOtherIncome.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'otherIncome',
        __component: 'questionnaire.checkbox-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 248,
          value: 'Personal',
        },
        screen: {
          id: 300,
          question: t(
            'questionnaire.publicHealthDe.signup.otherIncome.screen.question',
            'What form of income?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.otherIncome.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 7,
          mapValue: {
            CAPITALGAINS: t(
              'questionnaire.publicHealthDe.signup.otherIncome.option.capitalgainsOption',
              'Capital gains'
            ),
            RENTING: t(
              'questionnaire.publicHealthDe.signup.otherIncome.option.rentingOption',
              'Renting'
            ),
            OTHEREMPLOYMENT: t(
              'questionnaire.publicHealthDe.signup.otherIncome.option.otheremploymentOption',
              'Other Employment'
            ),
            PENSION: t(
              'questionnaire.publicHealthDe.signup.otherIncome.option.pensionOption',
              'Pension'
            ),
            OTHER: t(
              'questionnaire.publicHealthDe.signup.otherIncome.option.otherOption',
              'Other'
            ),
          },
        },
        type: 'CHECKBOX',
      },
      {
        id: 'otherIncomeMonthlyRevenue',
        __component: 'questionnaire.currency-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 249,
          value: 'Personal',
        },
        screen: {
          id: 301,
          question: t(
            'questionnaire.publicHealthDe.signup.otherIncomeMonthlyRevenue.screen.question',
            'How much per month?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.otherIncomeMonthlyRevenue.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 3,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.otherIncomeMonthlyRevenue.props.placeholder',
            'Monthly income'
          ),
        },
        type: 'CURRENCY',
      },
      {
        id: 'placeOfBirthCity',
        __component: 'questionnaire.input-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 242,
          value: 'Personal',
        },
        screen: {
          id: 294,
          question: t(
            'questionnaire.publicHealthDe.signup.placeOfBirthCity.screen.question',
            'What is your city of birth?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.placeOfBirthCity.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 29,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.placeOfBirthCity.props.placeholder',
            'City of birth'
          ),
          label: null,
          maxLength: null,
          minLength: null,
        },
        type: 'INPUT',
      },
      {
        id: 'placeOfBirthCountry',
        __component: 'questionnaire.country_single-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 115,
          value: 'Personal',
        },
        screen: {
          id: 170,
          question: t(
            'questionnaire.publicHealthDe.signup.placeOfBirthCountry.screen.question',
            'What is your country of birth?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.placeOfBirthCountry.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 2,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.placeOfBirthCountry.props.placeholder',
            'Country of birth'
          ),
        },
        type: 'COUNTRY_SINGLE',
      },
      {
        id: 'nationality',
        __component: 'questionnaire.country_multi-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 224,
          value: 'Personal',
        },
        screen: {
          id: 267,
          question: t(
            'questionnaire.publicHealthDe.signup.nationality.screen.question',
            'Which countries do you have citizenship in?'
          ),
          description: null,
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.nationality.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 5,
          placeholder: t(
            'questionnaire.publicHealthDe.signup.nationality.props.placeholder',
            'Country of citizenship'
          ),
        },
        type: 'COUNTRY_MULTI',
      },
      {
        id: 'receivesPension',
        __component: 'questionnaire.boolean-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 225,
          value: 'Personal',
        },
        screen: {
          id: 268,
          question: t(
            'questionnaire.publicHealthDe.signup.receivesPension.screen.question',
            'Are you currently receiving any money from a pension fund (state or non-state pension)?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.receivesPension.screen.description',
            'For most non-retired persons, the answer is no'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.receivesPension.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'hasDependentsToCover',
        __component: 'questionnaire.boolean-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 226,
          value: 'Personal',
        },
        screen: {
          id: 269,
          question: t(
            'questionnaire.publicHealthDe.signup.hasDependentsToCover.screen.question',
            'Would you like to cover dependents under your insurance policy?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.hasDependentsToCover.screen.description',
            'E.g. children or a non-working spouse permanently living in Germany. \n[Find out more](https://faq.feather-insurance.com/en/articles/28605-can-i-add-dependents-to-my-public-health-insurance-policy)'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasDependentsToCover.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: {
            id: 62,
            title: t(
              'questionnaire.publicHealthDe.signup.hasDependentsToCover.screen.additionalInfo.title',
              'What happens if I add dependents?'
            ),
            description: t(
              'questionnaire.publicHealthDe.signup.hasDependentsToCover.screen.additionalInfo.description',
              'You’ll receive an email from us shortly after sending your application with instructions on how to add dependents to your policy.'
            ),
            moreInfoLink: null,
          },
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'hasChildren',
        __component: 'questionnaire.boolean-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 227,
          value: 'Personal',
        },
        screen: {
          id: 270,
          question: t(
            'questionnaire.publicHealthDe.signup.hasChildren.screen.question',
            'Do you have any children under 25?'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.hasChildren.screen.description',
            'Claiming dependent children can lower your monthly bill, even if they are not added to your policy.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.hasChildren.screen.continueButtonText',
            'Continue'
          ),
          noMaxWidth: false,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        type: 'BOOLEAN',
        props: {},
      },
      {
        id: 'addons',
        __component: 'questionnaire.checkbox-question',
        required: true,
        groupId: 'signup',
        questionType: {
          id: 582,
          value: 'Personal',
        },
        screen: {
          id: 720,
          question: t(
            'questionnaire.publicHealthDe.signup.addons.screen.question',
            'Explore ways to enhance your coverage'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.addons.screen.description',
            'The coverage on public health insurance can feel limited for many, which is why we offer add-ons that extend this coverage.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.addons.screen.continueButtonText',
            'Send me an email'
          ),
          noMaxWidth: false,
          skipDetails: {
            id: 45,
            title: t(
              'questionnaire.publicHealthDe.signup.addons.screen.skipDetails.title',
              'Not right now'
            ),
            path: null,
            skipQuestion: {
              value: null,
            },
          },
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 13,
          mapValue: {
            DENTAL: {
              title: t(
                'questionnaire.publicHealthDe.signup.addons.option.dental.title',
                'Dental add-on'
              ),
              description: t(
                'questionnaire.publicHealthDe.signup.addons.option.dental.description',
                'Covers dental cleanings and additional treatments, with plans starting from €10.90/month'
              ),
            },
            TRAVEL: {
              title: t(
                'questionnaire.publicHealthDe.signup.addons.option.travel.title',
                'Travel add-on'
              ),
              description: t(
                'questionnaire.publicHealthDe.signup.addons.option.travel.description',
                'Helps you avoid medical expenses for trips outside of Europe for just €2/month'
              ),
            },
          },
        },
        type: 'CHECKBOX',
      },
      {
        id: 'signature',
        __component: 'questionnaire.signature_upload-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 317,
          value: 'Personal',
        },
        screen: {
          id: 384,
          question: t(
            'questionnaire.publicHealthDe.signup.signature.screen.question',
            'Sign your application'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.signature.screen.description',
            'In order to start processing your application, we need a clear signature as a means of consent.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.signature.screen.continueButtonText',
            'Review application'
          ),
          noMaxWidth: true,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 7,
          checkboxOptions: [
            {
              id: 9,
              title: t(
                'questionnaire.publicHealthDe.signup.signature.option.featherTcs.title',
                'I have read and understood the [privacy policy](https://feather-insurance.com/privacy-policy), [T&Cs](https://feather-insurance.com/terms-and-conditions) and [Feather broker mandate](https://content.cdn.feather-insurance.com/legal/sample-broker-mandate.pdf) and I hereby confirm that I give my full consent.'
              ),
              key: 'FEATHER_TCS',
            },
          ],
        },
        type: 'SIGNATURE_UPLOAD',
      },
      {
        id: 'signatureBarmer',
        __component: 'questionnaire.signature_upload-question',
        required: false,
        groupId: 'signup',
        questionType: {
          id: 318,
          value: 'Personal',
        },
        screen: {
          id: 385,
          question: t(
            'questionnaire.publicHealthDe.signup.signatureBarmer.screen.question',
            'Sign your application'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.signatureBarmer.screen.description',
            'In order to start processing your application, we need a clear signature as a means of consent.'
          ),
          continueButtonText: t(
            'questionnaire.publicHealthDe.signup.signatureBarmer.screen.continueButtonText',
            'Review application'
          ),
          noMaxWidth: true,
          skipDetails: null,
          additionalInfo: null,
          layout: 'Centered',
        },
        props: {
          id: 6,
          checkboxOptions: [
            {
              id: 11,
              title: t(
                'questionnaire.publicHealthDe.signup.signatureBarmer.option.featherTcs.title',
                'I have read and understood the [privacy policy](https://feather-insurance.com/privacy-policy), [T&Cs](https://feather-insurance.com/terms-and-conditions) and [Feather broker mandate](https://content.cdn.feather-insurance.com/legal/sample-broker-mandate.pdf) and I hereby confirm that I give my full consent.'
              ),
              key: 'FEATHER_TCS',
            },
            {
              id: 12,
              title: t(
                'questionnaire.publicHealthDe.signup.signatureBarmer.option.barmerTcs.title',
                "I'm aware that my data is processed for the purpose of clarifying the insurance relationship in accordance with §§ 5 ff. SGB V and for the collection of contributions in accordance with §§ 226 ff. SGB V, 57 SGB XI. BARMER stores this data for 9 years. The data related to the insurance relationship (§§ 288 SGB V, 99 SGB XI) are stored for a maximum of 30 years."
              ),
              key: 'BARMER_TCS',
            },
          ],
        },
        type: 'SIGNATURE_UPLOAD',
      },
      {
        id: 'review',
        __component: 'questionnaire.review',
        required: true,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 14,
          title: t(
            'questionnaire.publicHealthDe.signup.review.props.title',
            'Review your details'
          ),
          isDescriptionVisible: true,
          confirmationText: t(
            'questionnaire.publicHealthDe.signup.review.props.confirmationText',
            'I confirm that all answers are correct.'
          ),
          ctaText: t(
            'questionnaire.publicHealthDe.signup.review.props.ctaText',
            'Submit application'
          ),
          meta: {
            providerId: '{{answers.variant}}',
          },
          apiPath: '//',
          isIntermediate: false,
          autoStartDate: null,
          useUniqueEndpoint: true,
          hasEmptyQuote: true,
          skipCheckoutDocumentsGeneration: true,
          shouldTrackConversion: true,
          reviewValues: [
            {
              id: 122,
              path: 'email',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.email.title',
                'Email'
              ),
            },
            {
              id: 123,
              path: 'name',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.name.title',
                'Name'
              ),
            },
            {
              id: 124,
              path: 'lastNameAtBirth',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.lastNameAtBirth.title',
                'Last name at birth'
              ),
            },
            {
              id: 125,
              path: 'dateOfBirth',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.dateOfBirth.title',
                'Date of birth'
              ),
            },
            {
              id: 127,
              path: 'address',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.address.title',
                'Address'
              ),
            },
            {
              id: 128,
              path: 'occupation',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.occupation.title',
                'Occupation'
              ),
            },
            {
              id: 129,
              path: 'otherSituation',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.otherSituation.title',
                'Other occupation'
              ),
            },
            {
              id: 131,
              path: 'otherSituationDescription',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.otherSituationDescription.title',
                'Occupation details'
              ),
            },
            {
              id: 133,
              path: 'annualIncome',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.annualIncome.title',
                'Yearly income before taxes'
              ),
            },
            {
              id: 132,
              path: 'jobStartDate',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.jobStartDate.title',
                'Employment start date'
              ),
            },
            {
              id: 134,
              path: 'coverageStartDate',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.coverageStartDate.title',
                'Coverage start date'
              ),
            },
            {
              id: 135,
              path: 'university',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.university.title',
                'University'
              ),
            },
            {
              id: 136,
              path: 'universityName',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.universityName.title',
                'University name'
              ),
            },
            {
              id: 137,
              path: 'worksMoreThanTwentyHours',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.worksMoreThanTwentyHours.title',
                'Working more than 20 hours per week'
              ),
            },
            {
              id: 138,
              path: 'universityStartDate',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.universityStartDate.title',
                'Semester start date'
              ),
            },
            {
              id: 139,
              path: 'hasGermanPublicHealthInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.hasGermanPublicHealthInsurance.title',
                'Currently on public insurance in Germany'
              ),
            },
            {
              id: 140,
              path: 'hasPublicHealthInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.hasPublicHealthInsurance.title',
                'Currently on public insurance'
              ),
            },
            {
              id: 141,
              path: 'previousCountryOfInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.previousCountryOfInsurance.title',
                'Country of insurance'
              ),
            },
            {
              id: 142,
              path: 'hadOneDayPublicHealthInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.hadOneDayPublicHealthInsurance.title',
                'Publicly insured at least 1 day in the last 5 years'
              ),
            },
            {
              id: 143,
              path: 'pastFiveYearsInGermany',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.pastFiveYearsInGermany.title',
                'Lived in Germany within the last 5 years'
              ),
            },
            {
              id: 144,
              path: 'insuranceTwelveMonths',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.insuranceTwelveMonths.title',
                'Publicly insured for the last 12 months'
              ),
            },
            {
              id: 145,
              path: 'insuranceTwentyFourMonths',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.insuranceTwentyFourMonths.title',
                'Publicly insured for 24 months in last 5 years'
              ),
            },
            {
              id: 146,
              path: 'studentHasPublicHealthInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.studentHasPublicHealthInsurance.title',
                'Currently on public insurance'
              ),
            },
            {
              id: 147,
              path: 'studentPreviousCountryOfInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.studentPreviousCountryOfInsurance.title',
                'Country of insurance'
              ),
            },
            {
              id: 148,
              path: 'ehicCard',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.ehicCard.title',
                'Wants to use home country insurance in Germany'
              ),
            },
            {
              id: 149,
              path: 'expatOrPrivateHealthInsurance',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.expatOrPrivateHealthInsurance.title',
                'Has expat or private health insurance in Germany'
              ),
            },
            {
              id: 150,
              path: 'currentlyOnPrivate',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.currentlyOnPrivate.title',
                'Currently on private health insurance'
              ),
            },
            {
              id: 151,
              path: 'lastInsuranceInGermany',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.lastInsuranceInGermany.title',
                'Last insurance in Germany'
              ),
            },
            {
              id: 152,
              path: 'employmentWithinTwoMonthsOfArrival',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.employmentWithinTwoMonthsOfArrival.title',
                'Employment starts within 2 months of arrival'
              ),
            },
            {
              id: 155,
              path: 'previousInsurer',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.previousInsurer.title',
                'Current public insurance provider in Germany'
              ),
            },
            {
              id: 153,
              path: 'lastProviderInGermany',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.lastProviderInGermany.title',
                'Last public insurance provider in Germany'
              ),
            },
            {
              id: 154,
              path: 'unlistedPreviousInsurer',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.unlistedPreviousInsurer.title',
                'Insurance Provider'
              ),
            },
            {
              id: 157,
              path: 'placeOfBirthCity',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.placeOfBirthCity.title',
                'City of birth'
              ),
            },
            {
              id: 156,
              path: 'placeOfBirthCountry',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.placeOfBirthCountry.title',
                'Country of birth'
              ),
            },
            {
              id: 158,
              path: 'nationality',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.nationality.title',
                'Nationality'
              ),
            },
            {
              id: 159,
              path: 'hasDependentsToCover',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.hasDependentsToCover.title',
                'Has dependents to cover'
              ),
            },
            {
              id: 160,
              path: 'hasChildren',
              title: t(
                'questionnaire.publicHealthDe.signup.review.option.hasChildren.title',
                'Has children under 25'
              ),
            },
          ],
          transform: {
            personalInfo: [
              'email',
              'hasPublicHealth',
              'hasPublicHealthInActive',
              'name',
              'lastNameAtBirth',
              'dateOfBirth',
              'gender',
              'hasAddressInGermany',
              'address',
              'addressVar',
              'occupation',
              'otherSituation',
              'otherSituationDescription',
              'annualIncome',
              'jobStartDate',
              'firstTimeEmployedInGermany',
              'coverageStartDate',
              'universityInGermany',
              'university',
              'universityName',
              'universityAddress',
              'worksMoreThanTwentyHours',
              'universityStartDate',
              'hasGermanPublicHealthInsurance',
              'hasPublicHealthInsurance',
              'previousCountryOfInsurance',
              'hadOneDayPublicHealthInsurance',
              'pastFiveYearsInGermany',
              'insuranceTwelveMonths',
              'insuranceTwentyFourMonths',
              'studentHasPublicHealthInsurance',
              'studentPreviousCountryOfInsurance',
              'ehicCard',
              'expatOrPrivateHealthInsurance',
              'currentlyOnPrivate',
              'lastInsuranceInGermany',
              'employmentWithinTwoMonthsOfArrival',
              'lastProviderInGermany',
              'previousInsurer',
              'unlistedPreviousInsurer',
              'switchingFromPrivate',
              'dateFallingBelowThreshold',
              'employerName',
              'jobTitle',
              'companyAddress',
              'hasTaxNumber',
              'monthlyIncomeForNextYear',
              'agenturFurArbeitBenefits',
              'hasOtherIncome',
              'otherIncome',
              'otherIncomeMonthlyRevenue',
              'placeOfBirthCity',
              'placeOfBirthCountry',
              'nationality',
              'receivesPension',
              'hasDependentsToCover',
              'hasChildren',
              'addons',
              'signature',
              'signatureBarmer',
            ],
            tariffInfo: [],
          },
        },
        type: 'REVIEW',
      },
      {
        id: 'success',
        __component: 'questionnaire.success',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 3,
          title: t(
            'questionnaire.publicHealthDe.signup.success.props.title',
            'The next steps'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.success.props.description',
            'Here’s what happens after this.'
          ),
          infoCards: [
            {
              id: 3,
              title: t(
                'questionnaire.publicHealthDe.signup.success.option.0.title',
                'Approval of {{answers.variantData.name}}'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.success.option.0.children',
                'Within 5-10 days you will get notified by email.'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_mail_and_1_6e8e925a66/Icon_with_mail_and_1_6e8e925a66.png',
            },
            {
              id: 1,
              title: t(
                'questionnaire.publicHealthDe.signup.success.option.1.title',
                'Upload photo'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.success.option.1.children',
                'Done digitally in your account.'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_photo_and_2_be4bfa932a/Icon_with_photo_and_2_be4bfa932a.png',
            },
            {
              id: 2,
              title: t(
                'questionnaire.publicHealthDe.signup.success.option.2.title',
                'Receive health card'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.success.option.2.children',
                'By mail, a few weeks after photo upload or when insurance starts.'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_health_card_and_3_293e066a4a/Icon_with_health_card_and_3_293e066a4a.png',
            },
          ],
          buttonProps: [
            {
              id: 76,
              caption: t(
                'questionnaire.publicHealthDe.signup.success.option.0.caption',
                'Continue'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: t(
                'questionnaire.publicHealthDe.signup.success.option.0.href',
                '/me/policies?signupSuccess=PUBLIC_HEALTH',
                true
              ),
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              question: null,
            },
          ],
        },
        type: 'SUCCESS',
      },
      {
        id: 'successTk',
        __component: 'questionnaire.success',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 13,
          title: t(
            'questionnaire.publicHealthDe.signup.successTk.props.title',
            'The next steps'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.successTk.props.description',
            'Here’s what happens after this.'
          ),
          infoCards: [
            {
              id: 19,
              title: t(
                'questionnaire.publicHealthDe.signup.successTk.option.0.title',
                'Approval of {{answers.variantData.name}}'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.successTk.option.0.children',
                'Within 5-10 days you will get notified by email.'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_mail_and_1_6e8e925a66/Icon_with_mail_and_1_6e8e925a66.png',
            },
            {
              id: 22,
              title: t(
                'questionnaire.publicHealthDe.signup.successTk.option.1.title',
                'Submit your photo'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.successTk.option.1.children',
                'TK will send you a letter with the instructions'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_photo_and_2_be4bfa932a/Icon_with_photo_and_2_be4bfa932a.png',
            },
            {
              id: 21,
              title: t(
                'questionnaire.publicHealthDe.signup.successTk.option.2.title',
                'Receive health card'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.successTk.option.2.children',
                'By mail, a few weeks after photo upload or when insurance starts.'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_health_card_and_3_293e066a4a/Icon_with_health_card_and_3_293e066a4a.png',
            },
          ],
          buttonProps: [
            {
              id: 172,
              caption: t(
                'questionnaire.publicHealthDe.signup.successTk.option.0.caption',
                'Continue'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: t(
                'questionnaire.publicHealthDe.signup.successTk.option.0.href',
                '/me/policies?signupSuccess=PUBLIC_HEALTH',
                true
              ),
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              question: null,
            },
          ],
        },
        type: 'SUCCESS',
      },
      {
        id: 'successBkkfirmus',
        __component: 'questionnaire.success',
        required: false,
        groupId: 'signup',
        screen: {
          layout: 'Standalone',
        },
        props: {
          id: 14,
          title: t(
            'questionnaire.publicHealthDe.signup.successBkkfirmus.props.title',
            'The next steps'
          ),
          description: t(
            'questionnaire.publicHealthDe.signup.successBkkfirmus.props.description',
            'Here’s what happens after this.'
          ),
          infoCards: [
            {
              id: 20,
              title: t(
                'questionnaire.publicHealthDe.signup.successBkkfirmus.option.0.title',
                'Approval of {{answers.variantData.name}}'
              ),
              children: t(
                'questionnaire.publicHealthDe.signup.successBkkfirmus.option.0.children',
                'You will usually get notified by postal mail within 2 weeks.'
              ),
              icon: 'https://cms.cdn.feather-insurance.com/Icon_with_mail_4cae1eb8d0/Icon_with_mail_4cae1eb8d0.png',
            },
          ],
          buttonProps: [
            {
              id: 173,
              caption: t(
                'questionnaire.publicHealthDe.signup.successBkkfirmus.option.0.caption',
                'Continue'
              ),
              variant: 'PRIMARY',
              size: 'REGULAR',
              type: 'href',
              href: t(
                'questionnaire.publicHealthDe.signup.successBkkfirmus.option.0.href',
                '/me/policies?signupSuccess=PUBLIC_HEALTH',
                true
              ),
              value: {
                value: true,
              },
              redirectToQuestionId: null,
              question: null,
            },
          ],
        },
        type: 'SUCCESS',
      },
    ],
    rules: [
      {
        id: 'loading',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 278,
          op: 'isIn',
          variable: {
            id: 494,
            type: 'dynamic',
            value: ['aok', 'barmer', 'dak'],
            key: 'variant',
          },
        },
        then: {
          id: 597,
          goTo: 'intro',
        },
        else: null,
      },
      {
        id: 'loading',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 280,
          op: 'equals',
          variable: {
            id: 495,
            type: 'dynamic',
            value: 'tk',
            key: 'variant',
          },
        },
        then: {
          id: 598,
          goTo: 'introTk',
        },
        else: null,
      },
      {
        id: 'loading',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 279,
          op: 'equals',
          variable: {
            id: 496,
            type: 'dynamic',
            value: 'bkk_firmus',
            key: 'variant',
          },
        },
        then: {
          id: 596,
          goTo: 'introBkkfirmus',
        },
        else: null,
      },
      {
        id: 'hasPublicHealth',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 176,
          op: 'contains',
          variable: {
            id: 306,
            type: 'static',
            value: 'ACTIVE',
            key: null,
          },
        },
        then: {
          id: 377,
          goTo: 'hasPublicHealthInActive',
        },
        else: null,
      },
      {
        id: 'hasPublicHealth',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 144,
              op: 'contains',
              variable: {
                id: 308,
                type: 'static',
                value: 'PENDING',
                key: null,
              },
              variable2: null,
            },
            {
              id: 145,
              op: 'isNotDefined',
              variable: {
                id: 309,
                type: 'dynamic',
                value: true,
                key: 'hasPublicHealthInActive',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 380,
          goTo: 'hasPublicHealthInPendingBlocker',
        },
        else: null,
      },
      {
        id: 'hasPublicHealth',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 178,
          op: 'contains',
          variable: {
            id: 310,
            type: 'static',
            value: 'NO_POLICIES',
            key: null,
          },
        },
        then: {
          id: 381,
          goTo: 'name',
        },
        else: null,
      },
      {
        id: 'hasPublicHealthInActive',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 177,
          op: 'equals',
          variable: {
            id: 307,
            type: 'static',
            value: 'ADJUST_POLICY',
            key: null,
          },
        },
        then: {
          id: 378,
          goTo: 'hasPublicHealthInActiveBlocker',
        },
        else: null,
      },
      {
        id: 'gender',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 184,
          op: 'equals',
          variable: {
            id: 316,
            type: 'dynamic',
            value: 'bkk_firmus',
            key: 'variant',
          },
        },
        then: {
          id: 387,
          goTo: 'addressVar',
        },
        else: {
          id: 388,
          goTo: 'hasAddressInGermany',
        },
      },
      {
        id: 'hasAddressInGermany',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 30,
          op: 'equals',
          variable: {
            id: 30,
            type: 'static',
            value: true,
            key: 'hasAddressInGermany',
          },
        },
        then: {
          id: 51,
          goTo: 'address',
        },
        else: null,
      },
      {
        id: 'occupation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 79,
          op: 'equals',
          variable: {
            id: 98,
            type: 'static',
            value: 'UNIVERSITY_STUDENT',
            key: 'occupation',
          },
        },
        then: {
          id: 151,
          goTo: 'universityInGermany',
        },
        else: null,
      },
      {
        id: 'occupation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 32,
          op: 'isIn',
          variable: {
            id: 32,
            type: 'static',
            value: ['EMPLOYED', 'JOB_OFFER'],
            key: 'occupation',
          },
        },
        then: {
          id: 53,
          goTo: 'annualIncome',
        },
        else: null,
      },
      {
        id: 'occupation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 65,
          op: 'equals',
          variable: {
            id: 82,
            type: 'static',
            value: 'SELF_EMPLOYED',
            key: 'occupation',
          },
        },
        then: {
          id: 128,
          goTo: 'coverageStartDate',
        },
        else: null,
      },
      {
        id: 'occupation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 31,
          op: 'equals',
          variable: {
            id: 31,
            type: 'static',
            value: 'OTHER',
            key: 'occupation',
          },
        },
        then: {
          id: 52,
          goTo: 'otherSituation',
        },
        else: null,
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 66,
          op: 'isIn',
          variable: {
            id: 83,
            type: 'static',
            value: ['RETIRED', 'LANGUAGE_SCHOOL', 'JOB_HUNTING'],
            key: 'otherSituation',
          },
        },
        then: {
          id: 131,
          goTo: 'coverageStartDate',
        },
        else: null,
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 67,
          op: 'equals',
          variable: {
            id: 84,
            type: 'static',
            value: 'FAMILY_REUNION',
            key: 'otherSituation',
          },
        },
        then: {
          id: 133,
          goTo: 'familyReunionVisaBlocker',
        },
        else: null,
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 75,
          op: 'isIn',
          variable: {
            id: 92,
            type: 'static',
            value: ['APPRENTICE', 'FSJ'],
            key: 'otherSituation',
          },
        },
        then: {
          id: 145,
          goTo: 'jobStartDate',
        },
        else: null,
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 76,
          op: 'equals',
          variable: {
            id: 93,
            type: 'static',
            value: 'PHD',
            key: 'otherSituation',
          },
        },
        then: {
          id: 146,
          goTo: 'phdDoctorateBlocker',
        },
        else: null,
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 77,
          op: 'equals',
          variable: {
            id: 94,
            type: 'static',
            value: 'INTERN',
            key: 'otherSituation',
          },
        },
        then: {
          id: 147,
          goTo: 'internBlocker',
        },
        else: null,
      },
      {
        id: 'otherSituation',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 78,
          op: 'equals',
          variable: {
            id: 95,
            type: 'static',
            value: 'OTHER',
            key: 'otherSituation',
          },
        },
        then: {
          id: 148,
          goTo: 'otherSituationDescription',
        },
        else: null,
      },
      {
        id: 'otherSituationDescription',
        __component: 'questionnaire.rule-always',
        if: {
          id: 17,
          op: 'always',
        },
        then: {
          id: 278,
          goTo: 'coverageStartDate',
        },
        else: null,
      },
      {
        id: 'annualIncome',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 33,
          op: 'greaterThan',
          variable: {
            id: 33,
            type: 'static',
            value: '{{constants.miniJobThreshold}}',
            key: 'annualIncome',
          },
        },
        then: {
          id: 54,
          goTo: 'jobStartDate',
        },
        else: {
          id: 55,
          goTo: 'coverageStartDate',
        },
      },
      {
        id: 'jobStartDate',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 34,
          op: 'greaterThan',
          variable: {
            id: 34,
            type: 'dynamic',
            value: '{{constants.privateHealthInsuranceThreshold}}',
            key: 'annualIncome',
          },
        },
        then: {
          id: 56,
          goTo: 'firstTimeEmployedInGermany',
        },
        else: null,
      },
      {
        id: 'jobStartDate',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 149,
          op: 'isIn',
          variable: {
            id: 216,
            type: 'dynamic',
            value: ['APPRENTICE', 'FSJ'],
            key: 'otherSituation',
          },
        },
        then: {
          id: 285,
          goTo: 'hasGermanPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'jobStartDate',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 19,
              op: 'dateDiff',
              variable: {
                id: 22,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'gt',
                comparisonKey: 'jobStartDate',
              },
            },
            {
              id: 20,
              op: 'lessThan',
              variable: {
                id: 103,
                type: 'dynamic',
                value: '{{constants.privateHealthInsuranceThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 163,
          goTo: 'hasPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'jobStartDate',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 67,
              op: 'dateDiff',
              variable: {
                id: 38,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'lt',
                comparisonKey: 'jobStartDate',
              },
            },
            {
              id: 66,
              op: 'lessThan',
              variable: {
                id: 209,
                type: 'dynamic',
                value: '{{constants.privateHealthInsuranceThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 277,
          goTo: 'hasGermanPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'firstTimeEmployedInGermany',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 30,
              op: 'equals',
              variable: {
                id: 115,
                type: 'static',
                value: true,
                key: 'firstTimeEmployedInGermany',
              },
              variable2: null,
            },
            {
              id: 31,
              op: 'dateDiff',
              variable: {
                id: 24,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'gt',
                comparisonKey: 'jobStartDate',
              },
            },
          ],
        ],
        then: {
          id: 174,
          goTo: 'hasPublicHealthInsurance',
        },
        else: {
          id: 276,
          goTo: 'hasGermanPublicHealthInsurance',
        },
      },
      {
        id: 'coverageStartDate',
        __component: 'questionnaire.rule-always',
        if: {
          id: 10,
          op: 'always',
        },
        then: {
          id: 132,
          goTo: 'hasPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'universityInGermany',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 63,
          op: 'equals',
          variable: {
            id: 80,
            type: 'static',
            value: false,
            key: 'universityInGermany',
          },
        },
        then: {
          id: 126,
          goTo: 'universityInGermanyBlocker',
        },
        else: {
          id: 130,
          goTo: 'university',
        },
      },
      {
        id: 'university',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 72,
          op: 'equals',
          variable: {
            id: 89,
            type: 'static',
            value: '',
            key: 'university',
          },
        },
        then: {
          id: 138,
          goTo: 'universityNotListedBlocker',
        },
        else: {
          id: 139,
          goTo: 'worksMoreThanTwentyHours',
        },
      },
      {
        id: 'universityNotListedBlocker',
        __component: 'questionnaire.rule-always',
        if: {
          id: 26,
          op: 'always',
        },
        then: {
          id: 333,
          goTo: 'universityName',
        },
        else: null,
      },
      {
        id: 'universityName',
        __component: 'questionnaire.rule-always',
        if: {
          id: 11,
          op: 'always',
        },
        then: {
          id: 140,
          goTo: 'universityAddress',
        },
        else: null,
      },
      {
        id: 'universityAddress',
        __component: 'questionnaire.rule-always',
        if: {
          id: 12,
          op: 'always',
        },
        then: {
          id: 141,
          goTo: 'worksMoreThanTwentyHours',
        },
        else: null,
      },
      {
        id: 'worksMoreThanTwentyHours',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 73,
          op: 'equals',
          variable: {
            id: 90,
            type: 'static',
            value: true,
            key: 'worksMoreThanTwentyHours',
          },
        },
        then: {
          id: 142,
          goTo: 'worksMoreThanTwentyHoursBlocker',
        },
        else: {
          id: 144,
          goTo: 'universityStartDate',
        },
      },
      {
        id: 'universityStartDate',
        __component: 'questionnaire.rule-always',
        if: {
          id: 36,
          op: 'always',
        },
        then: {
          id: 375,
          goTo: 'studentHasPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'hasGermanPublicHealthInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 80,
          op: 'equals',
          variable: {
            id: 99,
            type: 'static',
            value: true,
            key: 'hasGermanPublicHealthInsurance',
          },
        },
        then: {
          id: 155,
          goTo: 'previousInsurer',
        },
        else: null,
      },
      {
        id: 'hasGermanPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 64,
              op: 'equals',
              variable: {
                id: 204,
                type: 'static',
                value: false,
                key: 'hasGermanPublicHealthInsurance',
              },
              variable2: null,
            },
            {
              id: 63,
              op: 'greaterThan',
              variable: {
                id: 205,
                type: 'dynamic',
                value: '{{constants.privateHealthInsuranceThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
            {
              id: 65,
              op: 'equals',
              variable: {
                id: 206,
                type: 'dynamic',
                value: false,
                key: 'firstTimeEmployedInGermany',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 271,
          goTo: 'currentlyOnPrivate',
        },
        else: null,
      },
      {
        id: 'hasPublicHealthInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 82,
          op: 'equals',
          variable: {
            id: 104,
            type: 'static',
            value: true,
            key: 'hasPublicHealthInsurance',
          },
        },
        then: {
          id: 166,
          goTo: 'previousCountryOfInsurance',
        },
        else: null,
      },
      {
        id: 'hasPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 23,
              op: 'equals',
              variable: {
                id: 105,
                type: 'static',
                value: false,
                key: 'hasPublicHealthInsurance',
              },
              variable2: null,
            },
            {
              id: 22,
              op: 'isIn',
              variable: {
                id: 106,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 21,
              op: 'dateDiff',
              variable: {
                id: 23,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'gt',
                comparisonKey: 'jobStartDate',
              },
            },
            {
              id: 117,
              op: 'greaterThan',
              variable: {
                id: 263,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 167,
          goTo: 'hadOneDayPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'hasPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 24,
              op: 'equals',
              variable: {
                id: 107,
                type: 'static',
                value: false,
                key: 'hasPublicHealthInsurance',
              },
              variable2: null,
            },
            {
              id: 25,
              op: 'equals',
              variable: {
                id: 108,
                type: 'dynamic',
                value: 'SELF_EMPLOYED',
                key: 'occupation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 168,
          goTo: 'ineligibleLearnOptions',
        },
        else: null,
      },
      {
        id: 'hasPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 69,
              op: 'equals',
              variable: {
                id: 217,
                type: 'static',
                value: false,
                key: null,
              },
              variable2: null,
            },
            {
              id: 70,
              op: 'isIn',
              variable: {
                id: 218,
                type: 'dynamic',
                value: ['RETIRED', 'LANGUAGE_SCHOOL', 'JOB_HUNTING'],
                key: 'otherSituation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 286,
          goTo: 'ineligibleExpatHealth',
        },
        else: null,
      },
      {
        id: 'hasPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 87,
              op: 'equals',
              variable: {
                id: 235,
                type: 'static',
                value: false,
                key: null,
              },
              variable2: null,
            },
            {
              id: 88,
              op: 'isIn',
              variable: {
                id: 236,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 116,
              op: 'lessThan',
              variable: {
                id: 265,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 296,
          goTo: 'ineligibleExpatHealth',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 146,
          op: 'equalsOrContainsCountryCode',
          variable: {
            id: 212,
            type: 'static',
            value: 'DE',
            key: 'previousCountryOfInsurance',
          },
        },
        then: {
          id: 281,
          goTo: 'previousInsurer',
        },
        else: null,
      },
      {
        id: 'hadOneDayPublicHealthInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 83,
          op: 'equals',
          variable: {
            id: 109,
            type: 'static',
            value: false,
            key: 'hadOneDayPublicHealthInsurance',
          },
        },
        then: {
          id: 170,
          goTo: 'pastFiveYearsInGermany',
        },
        else: null,
      },
      {
        id: 'pastFiveYearsInGermany',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 26,
              op: 'equals',
              variable: {
                id: 110,
                type: 'static',
                value: true,
                key: 'pastFiveYearsInGermany',
              },
              variable2: null,
            },
            {
              id: 27,
              op: 'greaterThan',
              variable: {
                id: 111,
                type: 'dynamic',
                value: '{{constants.privateHealthInsuranceThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 171,
          goTo: 'ineligibleOverPrivateThreshold',
        },
        else: null,
      },
      {
        id: 'pastFiveYearsInGermany',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 28,
              op: 'equals',
              variable: {
                id: 112,
                type: 'static',
                value: true,
                key: 'pastFiveYearsInGermany',
              },
              variable2: null,
            },
            {
              id: 29,
              op: 'lessThan',
              variable: {
                id: 113,
                type: 'dynamic',
                value: '{{constants.privateHealthInsuranceThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 172,
          goTo: 'ineligibleUnderPrivateThreshold',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 78,
              op: 'doCountryCodesMatch',
              variable: {
                id: 225,
                type: 'static',
                value: [
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 77,
              op: 'isIn',
              variable: {
                id: 226,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 76,
              op: 'dateDiff',
              variable: {
                id: 40,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'gt',
                comparisonKey: 'jobStartDate',
              },
            },
          ],
        ],
        then: {
          id: 291,
          goTo: 'insuranceHistoryProcessing',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 73,
              op: 'doCountryCodesNotMatch',
              variable: {
                id: 219,
                type: 'static',
                value: [
                  'DE',
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 71,
              op: 'isIn',
              variable: {
                id: 220,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 72,
              op: 'dateDiff',
              variable: {
                id: 39,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'gt',
                comparisonKey: 'jobStartDate',
              },
            },
            {
              id: 118,
              op: 'greaterThan',
              variable: {
                id: 264,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 287,
          goTo: 'hadOneDayPublicHealthInsurance',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 75,
              op: 'doCountryCodesMatch',
              variable: {
                id: 221,
                type: 'static',
                value: [
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 74,
              op: 'isIn',
              variable: {
                id: 222,
                type: 'dynamic',
                value: ['RETIRED', 'LANGUAGE_SCHOOL', 'JOB_HUNTING', 'OTHER'],
                key: 'otherSituation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 288,
          goTo: 'insuranceTwelveMonths',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 79,
              op: 'doCountryCodesMatch',
              variable: {
                id: 227,
                type: 'static',
                value: [
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 80,
              op: 'equals',
              variable: {
                id: 228,
                type: 'dynamic',
                value: 'SELF_EMPLOYED',
                key: 'occupation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 292,
          goTo: 'insuranceTwelveMonths',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 147,
              op: 'doCountryCodesMatch',
              variable: {
                id: 318,
                type: 'static',
                value: [
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 146,
              op: 'isIn',
              variable: {
                id: 319,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 148,
              op: 'dateDiff',
              variable: {
                id: 58,
                type: 'year',
                value: 55,
                key: 'dateOfBirth',
                dir: 'lt',
                comparisonKey: 'jobStartDate',
              },
            },
          ],
        ],
        then: {
          id: 391,
          goTo: 'insuranceTwelveMonths',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 81,
              op: 'doCountryCodesNotMatch',
              variable: {
                id: 230,
                type: 'static',
                value: [
                  'DE',
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 82,
              op: 'isIn',
              variable: {
                id: 229,
                type: 'dynamic',
                value: ['RETIRED', 'LANGUAGE_SCHOOL', 'JOB_HUNTING'],
                key: 'otherSituation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 293,
          goTo: 'ineligibleExpatHealth',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 84,
              op: 'doCountryCodesNotMatch',
              variable: {
                id: 231,
                type: 'static',
                value: [
                  'DE',
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 83,
              op: 'equals',
              variable: {
                id: 232,
                type: 'dynamic',
                value: 'SELF_EMPLOYED',
                key: 'occupation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 294,
          goTo: 'ineligibleLearnOptions',
        },
        else: null,
      },
      {
        id: 'previousCountryOfInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 86,
              op: 'doCountryCodesNotMatch',
              variable: {
                id: 233,
                type: 'static',
                value: [
                  'DE',
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IE',
                  'IT',
                  'LV',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                  'IS',
                  'LI',
                  'NO',
                  'UK',
                ],
                key: null,
              },
              variable2: null,
            },
            {
              id: 85,
              op: 'isIn',
              variable: {
                id: 234,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 295,
          goTo: 'ineligibleExpatHealth',
        },
        else: null,
      },
      {
        id: 'insuranceTwelveMonths',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 151,
          op: 'equals',
          variable: {
            id: 223,
            type: 'static',
            value: false,
            key: null,
          },
        },
        then: {
          id: 290,
          goTo: 'insuranceTwentyFourMonths',
        },
        else: null,
      },
      {
        id: 'insuranceTwentyFourMonths',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 90,
              op: 'equals',
              variable: {
                id: 237,
                type: 'static',
                value: false,
                key: null,
              },
              variable2: null,
            },
            {
              id: 89,
              op: 'notEquals',
              variable: {
                id: 238,
                type: 'dynamic',
                value: 'OTHER',
                key: 'otherSituation',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 297,
          goTo: 'ineligibleLearnOptions',
        },
        else: null,
      },
      {
        id: 'studentHasPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 142,
              op: 'dateDiff',
              variable: {
                id: 57,
                type: 'year',
                value: 30,
                key: 'dateOfBirth',
                dir: 'gt',
                comparisonKey: 'universityStartDate',
              },
            },
            {
              id: 143,
              op: 'equals',
              variable: {
                id: 304,
                type: 'static',
                value: false,
                key: null,
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 376,
          goTo: 'studentAboveAgeBlocker',
        },
        else: null,
      },
      {
        id: 'studentHasPublicHealthInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 85,
          op: 'equals',
          variable: {
            id: 116,
            type: 'static',
            value: true,
            key: 'studentHasPublicHealthInsurance',
          },
        },
        then: {
          id: 176,
          goTo: 'studentPreviousCountryOfInsurance',
        },
        else: null,
      },
      {
        id: 'studentHasPublicHealthInsurance',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 58,
              op: 'equals',
              variable: {
                id: 198,
                type: 'static',
                value: false,
                key: 'studentHasPublicHealthInsurance',
              },
              variable2: null,
            },
            {
              id: 62,
              op: 'dateDiff',
              variable: {
                id: 37,
                type: 'day',
                value: 1,
                key: 'universityStartDate',
                dir: 'gt',
                comparisonKey: null,
              },
            },
          ],
        ],
        then: {
          id: 262,
          goTo: 'expatOrPrivateHealthInsurance',
        },
        else: null,
      },
      {
        id: 'studentPreviousCountryOfInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 139,
          op: 'equalsOrContainsCountryCode',
          variable: {
            id: 196,
            type: 'static',
            value: 'DE',
            key: 'studentPreviousCountryOfInsurance',
          },
        },
        then: {
          id: 258,
          goTo: 'previousInsurer',
        },
        else: null,
      },
      {
        id: 'studentPreviousCountryOfInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 138,
          op: 'doCountryCodesMatch',
          variable: {
            id: 190,
            type: 'static',
            value: [
              'AT',
              'BE',
              'BG',
              'HR',
              'CY',
              'CZ',
              'DK',
              'EE',
              'FI',
              'FR',
              'GR',
              'HU',
              'IE',
              'IT',
              'LV',
              'LT',
              'LU',
              'MT',
              'NL',
              'PL',
              'PT',
              'RO',
              'SK',
              'SI',
              'ES',
              'SE',
              'CH',
              'IS',
              'LI',
              'NO',
              'UK',
              'MK',
              'ME',
              'RS',
              'TR',
              'BA',
              'TN',
            ],
            key: 'studentPreviousCountryOfInsurance',
          },
        },
        then: {
          id: 254,
          goTo: 'ehicCard',
        },
        else: null,
      },
      {
        id: 'ehicCard',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 140,
          op: 'equals',
          variable: {
            id: 197,
            type: 'static',
            value: true,
            key: 'ehicCard',
          },
        },
        then: {
          id: 260,
          goTo: 'weCanHelpStudentBlocker',
        },
        else: null,
      },
      {
        id: 'expatOrPrivateHealthInsurance',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 141,
          op: 'equals',
          variable: {
            id: 199,
            type: 'static',
            value: true,
            key: 'expatOrPrivateHealthInsurance',
          },
        },
        then: {
          id: 264,
          goTo: 'studentOnExpatOrPrivateBlocker',
        },
        else: null,
      },
      {
        id: 'currentlyOnPrivate',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 143,
          op: 'equals',
          variable: {
            id: 207,
            type: 'static',
            value: true,
            key: 'currentlyOnPrivate',
          },
        },
        then: {
          id: 272,
          goTo: 'ineligiblePrivateBlocker',
        },
        else: {
          id: 273,
          goTo: 'lastInsuranceInGermany',
        },
      },
      {
        id: 'lastInsuranceInGermany',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 144,
          op: 'equals',
          variable: {
            id: 211,
            type: 'static',
            value: 'PUBLIC',
            key: null,
          },
        },
        then: {
          id: 274,
          goTo: 'employmentWithinTwoMonthsOfArrival',
        },
        else: {
          id: 275,
          goTo: 'ineligiblePrivateBlocker',
        },
      },
      {
        id: 'employmentWithinTwoMonthsOfArrival',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 147,
          op: 'equals',
          variable: {
            id: 213,
            type: 'static',
            value: true,
            key: 'employmentWithinTwoMonthsOfArrival',
          },
        },
        then: {
          id: 282,
          goTo: 'lastProviderInGermany',
        },
        else: {
          id: 283,
          goTo: 'inEligibleTwoMonthsAfterArrivalBlocker',
        },
      },
      {
        id: 'previousInsurer',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 81,
          op: 'equals',
          variable: {
            id: 100,
            type: 'static',
            value: '',
            key: 'previousInsurer',
          },
        },
        then: {
          id: 156,
          goTo: 'unlistedPreviousInsurer',
        },
        else: null,
      },
      {
        id: 'lastProviderInGermany',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 148,
          op: 'equals',
          variable: {
            id: 214,
            type: 'static',
            value: '',
            key: null,
          },
        },
        then: {
          id: 284,
          goTo: 'unlistedPreviousInsurer',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 99,
              op: 'isIn',
              variable: {
                id: 247,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 101,
              op: 'lessThan',
              variable: {
                id: 248,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
            {
              id: 100,
              op: 'doCountryCodesMatch',
              variable: {
                id: 249,
                type: 'dynamic',
                value: [
                  'AT',
                  'BE',
                  'BG',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GR',
                  'HU',
                  'IS',
                  'IE',
                  'IT',
                  'LV',
                  'LI',
                  'LT',
                  'LU',
                  'MT',
                  'NL',
                  'NO',
                  'PL',
                  'PT',
                  'RO',
                  'SK',
                  'SI',
                  'ES',
                  'SE',
                  'CH',
                ],
                key: 'previousCountryOfInsurance',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 310,
          goTo: 'miniJobInsuredEuBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 91,
              op: 'isIn',
              variable: {
                id: 239,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 95,
              op: 'greaterThan',
              variable: {
                id: 242,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
            {
              id: 140,
              op: 'isNotDefined',
              variable: {
                id: 303,
                type: 'dynamic',
                value: true,
                key: 'previousInsurer',
              },
              variable2: null,
            },
            {
              id: 141,
              op: 'dateDiff',
              variable: {
                id: 56,
                type: 'day',
                value: 42,
                key: 'jobStartDate',
                dir: 'gt',
                comparisonKey: null,
              },
            },
          ],
        ],
        then: {
          id: 300,
          goTo: 'employerHasAlreadySignedUpBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 103,
              op: 'isIn',
              variable: {
                id: 250,
                type: 'dynamic',
                value: ['FSJ', 'APPRENTICE'],
                key: 'otherSituation',
              },
              variable2: null,
            },
            {
              id: 102,
              op: 'dateDiff',
              variable: {
                id: 46,
                type: 'day',
                value: 42,
                key: 'jobStartDate',
                dir: 'gt',
                comparisonKey: null,
              },
            },
            {
              id: 125,
              op: 'isNotDefined',
              variable: {
                id: 273,
                type: 'dynamic',
                value: true,
                key: 'previousInsurer',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 313,
          goTo: 'employerHasAlreadySignedUpBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 107,
              op: 'isIn',
              variable: {
                id: 254,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 106,
              op: 'greaterThan',
              variable: {
                id: 255,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
            {
              id: 105,
              op: 'equals',
              variable: {
                id: 256,
                type: 'dynamic',
                value: true,
                key: 'hasGermanPublicHealthInsurance',
              },
              variable2: null,
            },
            {
              id: 108,
              op: 'dateDiff',
              variable: {
                id: 47,
                type: 'day',
                value: 14,
                key: 'jobStartDate',
                dir: 'gt',
                comparisonKey: null,
              },
            },
          ],
        ],
        then: {
          id: 324,
          goTo: 'switchEmployedProvidersBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 109,
              op: 'isIn',
              variable: {
                id: 257,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 110,
              op: 'greaterThan',
              variable: {
                id: 258,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
            {
              id: 111,
              op: 'equalsOrContainsCountryCode',
              variable: {
                id: 259,
                type: 'dynamic',
                value: 'DE',
                key: 'previousCountryOfInsurance',
              },
              variable2: null,
            },
            {
              id: 112,
              op: 'dateDiff',
              variable: {
                id: 48,
                type: 'day',
                value: 14,
                key: 'jobStartDate',
                dir: 'gt',
                comparisonKey: null,
              },
            },
          ],
        ],
        then: {
          id: 325,
          goTo: 'switchEmployedProvidersBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 113,
              op: 'isIn',
              variable: {
                id: 260,
                type: 'dynamic',
                value: ['FSJ', 'APPRENTICE'],
                key: 'otherSituation',
              },
              variable2: null,
            },
            {
              id: 114,
              op: 'equals',
              variable: {
                id: 261,
                type: 'dynamic',
                value: true,
                key: 'hasGermanPublicHealthInsurance',
              },
              variable2: null,
            },
            {
              id: 115,
              op: 'dateDiff',
              variable: {
                id: 49,
                type: 'day',
                value: 14,
                key: 'jobStartDate',
                dir: 'gt',
                comparisonKey: null,
              },
            },
          ],
        ],
        then: {
          id: 326,
          goTo: 'switchEmployedProvidersBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 136,
              op: 'isDefined',
              variable: {
                id: 292,
                type: 'dynamic',
                value: true,
                key: 'previousInsurer',
              },
              variable2: null,
            },
            {
              id: 137,
              op: 'isNotDefined',
              variable: {
                id: 293,
                type: 'dynamic',
                value: true,
                key: 'switchEmployedProvidersBlocker',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 357,
          goTo: 'switchProvidersBlocker',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 97,
              op: 'isIn',
              variable: {
                id: 243,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 96,
              op: 'greaterThan',
              variable: {
                id: 244,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 304,
          goTo: 'employerName',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 153,
          op: 'isIn',
          variable: {
            id: 252,
            type: 'dynamic',
            value: ['FSJ', 'APPRENTICE'],
            key: 'otherSituation',
          },
        },
        then: {
          id: 315,
          goTo: 'employerName',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 119,
              op: 'isIn',
              variable: {
                id: 266,
                type: 'dynamic',
                value: ['EMPLOYED', 'JOB_OFFER'],
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 120,
              op: 'lessThan',
              variable: {
                id: 267,
                type: 'dynamic',
                value: '{{constants.miniJobThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 328,
          goTo: 'hasTaxNumber',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 156,
          op: 'isIn',
          variable: {
            id: 268,
            type: 'dynamic',
            value: ['SELF_EMPLOYED'],
            key: 'occupation',
          },
        },
        then: {
          id: 329,
          goTo: 'hasTaxNumber',
        },
        else: null,
      },
      {
        id: 'insuranceHistoryProcessing',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 157,
          op: 'isIn',
          variable: {
            id: 269,
            type: 'dynamic',
            value: ['RETIRED', 'LANGUAGE_SCHOOL', 'JOB_HUNTING', 'OTHER'],
            key: 'otherSituation',
          },
        },
        then: {
          id: 330,
          goTo: 'hasTaxNumber',
        },
        else: null,
      },
      {
        id: 'employerHasAlreadySignedUpBlocker',
        __component: 'questionnaire.rule-group-comparison',
        if: [
          'AND',
          [
            {
              id: 242,
              op: 'equals',
              variable: {
                id: 501,
                type: 'dynamic',
                value: 'EMPLOYED',
                key: 'occupation',
              },
              variable2: null,
            },
            {
              id: 243,
              op: 'lessThan',
              variable: {
                id: 500,
                type: 'dynamic',
                value: '{{constants.privateHealthInsuranceThreshold}}',
                key: 'annualIncome',
              },
              variable2: null,
            },
          ],
        ],
        then: {
          id: 608,
          goTo: 'switchingFromPrivate',
        },
        else: null,
      },
      {
        id: 'switchingFromPrivate',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 283,
          op: 'equals',
          variable: {
            id: 499,
            type: 'static',
            value: true,
            key: null,
          },
        },
        then: {
          id: 607,
          goTo: 'dateFallingBelowThreshold',
        },
        else: null,
      },
      {
        id: 'employerName',
        __component: 'questionnaire.rule-always',
        if: {
          id: 19,
          op: 'always',
        },
        then: {
          id: 311,
          goTo: 'jobTitle',
        },
        else: null,
      },
      {
        id: 'jobTitle',
        __component: 'questionnaire.rule-always',
        if: {
          id: 20,
          op: 'always',
        },
        then: {
          id: 312,
          goTo: 'companyAddress',
        },
        else: null,
      },
      {
        id: 'hasTaxNumber',
        __component: 'questionnaire.rule-always',
        if: {
          id: 22,
          op: 'always',
        },
        then: {
          id: 317,
          goTo: 'monthlyIncomeForNextYear',
        },
        else: null,
      },
      {
        id: 'monthlyIncomeForNextYear',
        __component: 'questionnaire.rule-always',
        if: {
          id: 23,
          op: 'always',
        },
        then: {
          id: 318,
          goTo: 'agenturFurArbeitBenefits',
        },
        else: null,
      },
      {
        id: 'agenturFurArbeitBenefits',
        __component: 'questionnaire.rule-always',
        if: {
          id: 24,
          op: 'always',
        },
        then: {
          id: 319,
          goTo: 'hasOtherIncome',
        },
        else: null,
      },
      {
        id: 'hasOtherIncome',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 154,
          op: 'equals',
          variable: {
            id: 253,
            type: 'static',
            value: true,
            key: null,
          },
        },
        then: {
          id: 321,
          goTo: 'otherIncome',
        },
        else: null,
      },
      {
        id: 'otherIncome',
        __component: 'questionnaire.rule-always',
        if: {
          id: 25,
          op: 'always',
        },
        then: {
          id: 320,
          goTo: 'otherIncomeMonthlyRevenue',
        },
        else: null,
      },
      {
        id: 'addons',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 185,
          op: 'equals',
          variable: {
            id: 317,
            type: 'dynamic',
            value: 'barmer',
            key: 'variant',
          },
        },
        then: {
          id: 389,
          goTo: 'signatureBarmer',
        },
        else: {
          id: 390,
          goTo: 'signature',
        },
      },
      {
        id: 'review',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 284,
          op: 'isIn',
          variable: {
            id: 502,
            type: 'dynamic',
            value: ['aok', 'barmer', 'dak'],
            key: 'variant',
          },
        },
        then: {
          id: 611,
          goTo: 'success',
        },
        else: null,
      },
      {
        id: 'review',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 285,
          op: 'equals',
          variable: {
            id: 503,
            type: 'dynamic',
            value: 'tk',
            key: 'variant',
          },
        },
        then: {
          id: 609,
          goTo: 'successTk',
        },
        else: null,
      },
      {
        id: 'review',
        __component: 'questionnaire.rule-comparison',
        if: {
          id: 286,
          op: 'equals',
          variable: {
            id: 504,
            type: 'dynamic',
            value: 'bkk_firmus',
            key: 'variant',
          },
        },
        then: {
          id: 610,
          goTo: 'successBkkfirmus',
        },
        else: null,
      },
    ],
    calculatedFields: [],
    removeAnswersLogic: {
      loading: {
        op: 'always',
        questions: ['review'],
      },
      intro: {
        op: 'always',
        questions: ['review'],
      },
      introTk: {
        op: 'always',
        questions: ['review'],
      },
      introBkkfirmus: {
        op: 'always',
        questions: ['review'],
      },
      email: {
        op: 'always',
        questions: ['review'],
      },
      hasPublicHealth: {
        op: 'always',
        questions: ['review'],
      },
      hasPublicHealthInActive: {
        op: 'always',
        questions: ['review'],
      },
      hasPublicHealthInPendingBlocker: {
        op: 'always',
        questions: ['review'],
      },
      hasPublicHealthInActiveBlocker: {
        op: 'always',
        questions: ['review'],
      },
      name: {
        op: 'always',
        questions: ['review'],
      },
      lastNameAtBirth: {
        op: 'always',
        questions: ['review'],
      },
      dateOfBirth: {
        op: 'always',
        questions: ['review'],
      },
      gender: {
        op: 'always',
        questions: ['review'],
      },
      hasAddressInGermany: {
        op: 'always',
        questions: ['review'],
      },
      address: {
        op: 'always',
        questions: ['review'],
      },
      addressVar: {
        op: 'always',
        questions: ['review'],
      },
      occupation: {
        op: 'always',
        questions: ['review'],
      },
      otherSituation: {
        op: 'always',
        questions: ['review'],
      },
      otherSituationDescription: {
        op: 'always',
        questions: ['review'],
      },
      annualIncome: {
        op: 'always',
        questions: ['review'],
      },
      jobStartDate: {
        op: 'always',
        questions: ['review'],
      },
      firstTimeEmployedInGermany: {
        op: 'always',
        questions: ['review'],
      },
      coverageStartDate: {
        op: 'always',
        questions: ['review'],
      },
      universityInGermany: {
        op: 'always',
        questions: ['review'],
      },
      universityInGermanyBlocker: {
        op: 'always',
        questions: ['review'],
      },
      university: {
        op: 'always',
        questions: ['review'],
      },
      universityNotListedBlocker: {
        op: 'always',
        questions: ['review'],
      },
      universityName: {
        op: 'always',
        questions: ['review'],
      },
      universityAddress: {
        op: 'always',
        questions: ['review'],
      },
      worksMoreThanTwentyHours: {
        op: 'always',
        questions: ['review'],
      },
      worksMoreThanTwentyHoursBlocker: {
        op: 'always',
        questions: ['review'],
      },
      universityStartDate: {
        op: 'always',
        questions: ['review'],
      },
      familyReunionVisaBlocker: {
        op: 'always',
        questions: ['review'],
      },
      phdDoctorateBlocker: {
        op: 'always',
        questions: ['review'],
      },
      internBlocker: {
        op: 'always',
        questions: ['review'],
      },
      hasGermanPublicHealthInsurance: {
        op: 'always',
        questions: ['review'],
      },
      hasPublicHealthInsurance: {
        op: 'always',
        questions: ['review'],
      },
      previousCountryOfInsurance: {
        op: 'always',
        questions: ['review'],
      },
      hadOneDayPublicHealthInsurance: {
        op: 'always',
        questions: ['review'],
      },
      pastFiveYearsInGermany: {
        op: 'always',
        questions: ['review'],
      },
      insuranceTwelveMonths: {
        op: 'always',
        questions: ['review'],
      },
      insuranceTwentyFourMonths: {
        op: 'always',
        questions: ['review'],
      },
      studentHasPublicHealthInsurance: {
        op: 'always',
        questions: ['review'],
      },
      studentAboveAgeBlocker: {
        op: 'always',
        questions: ['review'],
      },
      studentPreviousCountryOfInsurance: {
        op: 'always',
        questions: ['review'],
      },
      ehicCard: {
        op: 'always',
        questions: ['review'],
      },
      weCanHelpStudentBlocker: {
        op: 'always',
        questions: ['review'],
      },
      expatOrPrivateHealthInsurance: {
        op: 'always',
        questions: ['review'],
      },
      studentOnExpatOrPrivateBlocker: {
        op: 'always',
        questions: ['review'],
      },
      currentlyOnPrivate: {
        op: 'always',
        questions: ['review'],
      },
      lastInsuranceInGermany: {
        op: 'always',
        questions: ['review'],
      },
      employmentWithinTwoMonthsOfArrival: {
        op: 'always',
        questions: ['review'],
      },
      inEligibleTwoMonthsAfterArrivalBlocker: {
        op: 'always',
        questions: ['review'],
      },
      ineligibleOverPrivateThreshold: {
        op: 'always',
        questions: ['review'],
      },
      ineligibleUnderPrivateThreshold: {
        op: 'always',
        questions: ['review'],
      },
      ineligibleExpatHealth: {
        op: 'always',
        questions: ['review'],
      },
      ineligibleLearnOptions: {
        op: 'always',
        questions: ['review'],
      },
      ineligiblePrivateBlocker: {
        op: 'always',
        questions: ['review'],
      },
      lastProviderInGermany: {
        op: 'always',
        questions: ['review'],
      },
      previousInsurer: {
        op: 'always',
        questions: ['review'],
      },
      unlistedPreviousInsurer: {
        op: 'always',
        questions: ['review'],
      },
      insuranceHistoryProcessing: {
        op: 'always',
        questions: ['review'],
      },
      miniJobInsuredEuBlocker: {
        op: 'always',
        questions: ['review'],
      },
      switchEmployedProvidersBlocker: {
        op: 'always',
        questions: ['review'],
      },
      switchProvidersBlocker: {
        op: 'always',
        questions: ['review'],
      },
      employerHasAlreadySignedUpBlocker: {
        op: 'always',
        questions: ['review'],
      },
      switchingFromPrivate: {
        op: 'always',
        questions: ['review'],
      },
      dateFallingBelowThreshold: {
        op: 'always',
        questions: ['review'],
      },
      employerName: {
        op: 'always',
        questions: ['review'],
      },
      jobTitle: {
        op: 'always',
        questions: ['review'],
      },
      companyAddress: {
        op: 'always',
        questions: ['review'],
      },
      hasTaxNumber: {
        op: 'always',
        questions: ['review'],
      },
      monthlyIncomeForNextYear: {
        op: 'always',
        questions: ['review'],
      },
      agenturFurArbeitBenefits: {
        op: 'always',
        questions: ['review'],
      },
      hasOtherIncome: {
        op: 'always',
        questions: ['review'],
      },
      otherIncome: {
        op: 'always',
        questions: ['review'],
      },
      otherIncomeMonthlyRevenue: {
        op: 'always',
        questions: ['review'],
      },
      placeOfBirthCity: {
        op: 'always',
        questions: ['review'],
      },
      placeOfBirthCountry: {
        op: 'always',
        questions: ['review'],
      },
      nationality: {
        op: 'always',
        questions: ['review'],
      },
      receivesPension: {
        op: 'always',
        questions: ['review'],
      },
      hasDependentsToCover: {
        op: 'always',
        questions: ['review'],
      },
      hasChildren: {
        op: 'always',
        questions: ['review'],
      },
      addons: {
        op: 'always',
        questions: ['review'],
      },
      signature: {
        op: 'always',
        questions: ['review'],
      },
      signatureBarmer: {
        op: 'always',
        questions: ['review'],
      },
    },
  };
};
